// import React, { useEffect, useState, useRef } from "react";
// import {
//   Button,
//   Spinner,
//   Input,
//   Row,
//   Col,
//   Label,
// } from "reactstrap";

// import { useNavigate } from "react-router-dom";

// import swal from "sweetalert";

// import {
//   SaveProduct,
//   AllCategoryList,
//   _GetByUrl,
//   _BulkUpload,
//   _Put,
// } from "../../ApiEndPoint/ApiCalling";

// import {
//   Bulk_Update_Product,
//   Bulk_Upload_Product,
//   Update_Product,
//   viewUnits,
// } from "../../ApiEndPoint/Api";

// import axiosConfig from "../../AxiosConfig";
// import { useSearchParams } from "react-router-dom";
// export default function AddProduct() {
//   const [showStepDropdown, setShowStepDropdown] = useState(false);
//   const stepDropdownRef = useRef(null);
//   const [productDetails, setProductDetails] = useState([
//     {
//       productId: "",
//       units: [],
//       noOfPieceInSheet: "",
//       selectedUnits: [],

//     },

//   ]);
//   const [productQtyDetails, setProductQtyDetails] = useState([
//     {
//       productId: "",
//       qty: "",
//     },
//   ]);
//   const [savedSelectedUnits, setSavedSelectedUnits] = useState([]);
//   const [openUnitDropdown, setOpenUnitDropdown] = useState(null);
//   const STORAGE_KEY = "add_product_form";
//   const [stockUnit, setStockUnit] = useState("");
//   const [searchParams] = useSearchParams();

//   const view = searchParams.get("view");

//   const isEdit = view?.includes("edit-product");

//   const productId = view?.split("edit-product-")[1];
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);
//   // ✅ BULK UPLOAD
//   const [BulkUpload, setBulkUpload] = useState(false);
//   const [BulkImport, setBulkImport] = useState(null);

//   const [uploadForm, setUploadForm] = useState({
//     UploadStatus: "",
//   });

//   const [warehouses, setWarehouses] =
//     useState([]);

//   const [categories, setCategories] =
//     useState([]);

//   const [subCategories, setSubCategories] =
//     useState([]);

//   const [units, setUnits] = useState([]);
//   const [productSections, setProductSections] =
//     useState([]);
//   const [productstep, setProductStep] = useState([]);
//   const [rawProducts, setRawProducts] =
//     useState([]);

//   const [costingRows, setCostingRows] =
//     useState([]);

//   const [selectedCostProduct, setSelectedCostProduct] =
//     useState("");
//   const [products, setProducts] = useState([]);
//   // ✅ MULTI UNIT
//   const [formValues, setFormValues] =
//     useState([
//       {
//         unit: "",
//         qty: "",
//       },
//     ]);

//   // ✅ FORM
//   const [form, setForm] = useState({
//     Product_Title: "",
//     Product_MRP: "",
//     step_Name: [],
//     openingRate: "" || 0,
//     Purchase_Rate: "",
//     HSN_Code: "",
//     GSTRate: "",
//     Opening_Stock: "",
//     producttype: "",
//     MIN_stockalert: "",
//     landedCost: "",
//     category: "",
//     SubCategory: "",
//     warehouse: "",
//     primaryUnit: "",
//     secondaryUnit: "",
//     secondarySize: "",
//     status: "Active",
//     productType: "Parent",
//   });
//   useEffect(() => {

//     if (!isEdit) {

//       const savedData =
//         localStorage.getItem(STORAGE_KEY);

//       if (savedData) {

//         const parsed =
//           JSON.parse(savedData);

//         if (parsed?.form) {
//           setForm(parsed.form);
//         }

//         if (parsed?.formValues) {
//           setFormValues(parsed.formValues);
//         }
//         if (parsed?.stockUnit) {
//           setStockUnit(parsed.stockUnit);
//         }
//       }
//     }

//   }, []);
//   useEffect(() => {
//     if (isEdit && productId && products.length > 0) {
//       getSingleProduct();
//     }
//   }, [isEdit, productId, products]);
//   const getSingleProduct = async () => {

//     try {

//       setLoading(true);

//       const user = JSON.parse(
//         localStorage.getItem("userData")
//       );

//       const res = await axiosConfig.get(
//         `/product/view-product-by-id/${productId}`
//       );
//       const data = res?.data?.Product;
//       console.log("EDIT DATA", data);
//       setForm({
//         Product_Title: data?.Product_Title || "",
//         Product_MRP: data?.Product_MRP || "",
//         Purchase_Rate: data?.Purchase_Rate || "",
//         HSN_Code: data?.HSN_Code || "",
//         GSTRate: data?.GSTRate || "",
//         Opening_Stock: data?.Opening_Stock || "",
//         producttype: data?.producttype || "",
//         MIN_stockalert: data?.MIN_stockalert || "",
//         landedCost: data?.Purchase_Rate || "",
//         category: data?.category || "",
//         SubCategory: data?.SubCategory || "",
//         warehouse: data?.warehouse || "",
//         openingRate: data?.openingRate || "",
//         primaryUnit: data?.primaryUnit || "",
//         secondaryUnit: data?.secondaryUnit || "",
//         secondarySize: data?.secondarySize || "",
//         step_Name: Array.isArray(data?.step_Name)
//           ? data.step_Name
//           : data?.step_Name
//             ? [data.step_Name]
//             : [],
//         productType: data?.productType || "Parent",
//         status: data?.status || "Active",
//       });
//       // Product Details
//       //     if (data?.productDetails?.length > 0) {
//       //   const editProductDetails = data.productDetails.map((item) => {

//       //     const selectedProduct = products.find(
//       //       (p) => String(p._id) === String(item.productId)
//       //     );

//       //     return {
//       //       productId: item.productId,

//       //       noOfPieceInSheet:
//       //         item.noOfPieceInSheet ?? "",

//       //       // Product ke original units
//       //       units: selectedProduct?.Units || [],

//       //       // Database se saved selectedUnits
//       //      selectedUnits: Array.isArray(item.selectedUnits)
//       //     };
//       //   });

//       //   console.log(
//       //     "EDIT PRODUCT DETAILS =>",
//       //     editProductDetails
//       //   );

//       //   setProductDetails(editProductDetails);
//       // }
//       if (data?.productDetails?.length > 0) {

//         const editProductDetails = data.productDetails.map((item) => {

//           const selectedProduct = products.find(
//             (p) => String(p._id) === String(item.productId)
//           );

//           return {
//             productId: item.productId,

//             noOfPieceInSheet:
//               item.noOfPieceInSheet ?? "",

//             units: selectedProduct?.Units || [],

//             selectedUnits: [],
//           };
//         });

//         // Saved selected units ko temporary rakho
//         setSavedSelectedUnits(
//           data.productDetails.map((item) => ({
//             productId:
//               typeof item.productId === "object"
//                 ? item.productId?._id
//                 : item.productId,

//             selectedUnits: Array.isArray(item.selectedUnits)
//               ? item.selectedUnits.map((u) => ({
//                 unit: u?.unit || "",
//                 qty:
//                   u?.qty !== undefined &&
//                     u?.qty !== null
//                     ? u.qty
//                     : "",
//               }))
//               : [],
//           }))
//         );

//         setProductDetails(editProductDetails);
//       }
//       // ================= PRODUCT + QTY DETAILS =================

//       if (data?.productQtyDetails?.length > 0) {
//         setProductQtyDetails(
//           data.productQtyDetails.map((item) => ({
//             productId:
//               typeof item.productId === "object"
//                 ? item.productId._id
//                 : item.productId,

//             qty: item.qty ?? "",
//           }))
//         );
//       } else {
//         setProductQtyDetails([
//           {
//             productId: "",
//             qty: "",
//           },
//         ]);
//       }
//       if (data?.productCosting?.length > 0) {
//         setCostingRows(data.productCosting);
//       }
//       console.log("API ProductType=", data.productType);
//       setStockUnit(data?.stockUnit || "");
//       // ✅ Units set
//       if (data?.Units?.length > 0) {
//         setFormValues(
//           data?.Units.map((u) => ({
//             unit: u?.unit,
//             qty: u?.qty,
//           }))
//         );
//       }

//     } catch (err) {

//       console.log(err);

//     } finally {

//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (
//         stepDropdownRef.current &&
//         !stepDropdownRef.current.contains(event.target)
//       ) {
//         setShowStepDropdown(false);
//       }
//     };

//     document.addEventListener("mousedown", handleOutsideClick);

//     return () => {
//       document.removeEventListener("mousedown", handleOutsideClick);
//     };
//   }, []);
//   useEffect(() => {
//     if (!products.length) return;

//     setProductDetails((prev) =>
//       prev.map((item) => {
//         const product = products.find(
//           (p) => p._id === item.productId
//         );

//         return {
//           ...item,
//           units: product?.Units || [],
//         };
//       })
//     );
//   }, [products]);
//   useEffect(() => {

//     if (categories.length > 0 && form.category) {

//       const selectedCategory = categories.find(
//         (c) => c.name === form.category
//       );

//       setSubCategories(
//         selectedCategory?.subcategories || []
//       );

//     }

//   }, [categories, form.category]);

//   useEffect(() => {

//     const fetchAllData = async () => {

//       try {

//         const user = JSON.parse(
//           localStorage.getItem("userData")
//         );

//         if (!user?.database) return;

//         // ✅ UNITS
//         const unitRes = await _GetByUrl(
//           viewUnits,
//           user.database
//         );
//         const dynamicUnits = unitRes?.dynamicUnit || [];

//         // ✅ parent _id attach karo
//         const allUnits = dynamicUnits.flatMap((item) =>
//           (item.Units || []).map((u) => ({
//             ...u,
//             parentId: item._id,
//           }))
//         );
//         setUnits(
//           allUnits || []
//         );
//         // ✅ WAREHOUSE
//         const warehouseRes =
//           await axiosConfig.get(
//             `/warehouse/view-warehouse/${user.database}`
//           );

//         setWarehouses(
//           warehouseRes?.data?.Warehouse || []
//         );

//         // ✅ CATEGORY
//         const categoryRes =
//           await AllCategoryList(
//             user._id,
//             user.database
//           );

//         setCategories(
//           categoryRes?.Category || []
//         );
//         // ✅ PRODUCT SECTION
//         const sectionRes =
//           await axiosConfig.get(
//             `/product-type/view-producttype/${user.database}`
//           );

//         setProductSections(
//           sectionRes?.data?.productType || []
//         );
//         const productStep = await axiosConfig.get(`/production-step/view-steps/${user?._id}`)
//         setProductStep(productStep?.data?.steps);

//         // ✅ RAW MATERIAL PRODUCTS
//         const res = await axiosConfig.get(
//           `/product/view-product-purchase/${user.database}`
//         );
//         setProducts(res?.data?.Product || []);
//         const rawMaterialProducts =
//           res?.data?.Product?.filter(
//             (item) =>
//               item?.category?.toLowerCase() === "sales" &&
//               item?.producttype?.toLowerCase() === "raw material"
//           ) || [];
//         setRawProducts(rawMaterialProducts.reverse());
//       } catch (err) {

//         console.log(err);

//       }
//     };

//     fetchAllData();

//   }, []);
//   useEffect(() => {

//     if (!isEdit) {

//       const formData = {
//         form,
//         formValues,
//         stockUnit,
//       };

//       localStorage.setItem(
//         STORAGE_KEY,
//         JSON.stringify(formData)
//       );
//     }

//   }, [form, formValues, stockUnit]);


//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (!e.target.closest(".unit-dropdown-wrapper")) {
//         setOpenUnitDropdown(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener(
//         "mousedown",
//         handleClickOutside
//       );
//     };
//   }, []);
//   useEffect(() => {
//     if (!form.SubCategory) {
//       setProductDetails((prev) =>
//         prev.map((item) => ({
//           ...item,
//           selectedUnits: [],
//         }))
//       );

//       return;
//     }

//     if (!subCategories.length) return;

//     const selectedSubCategory = subCategories.find(
//       (sub) =>
//         String(sub.name).trim().toLowerCase() ===
//         String(form.SubCategory).trim().toLowerCase()
//     );

//     const subCategoryUnits =
//       selectedSubCategory?.units || [];

//     setProductDetails((prev) =>
//       prev.map((item) => {

//         const savedItem = savedSelectedUnits.find(
//           (saved) =>
//             String(saved.productId) ===
//             String(
//               typeof item.productId === "object"
//                 ? item.productId?._id
//                 : item.productId
//             )
//         );

//         const oldUnits =
//           savedItem?.selectedUnits ||
//           item.selectedUnits ||
//           [];

//         const updatedSelectedUnits =
//           subCategoryUnits.map((unit) => {

//             const unitName =
//               unit?.unitName ||
//               unit?.unit ||
//               "";

//             const oldUnit = oldUnits.find(
//               (old) =>
//                 String(old.unit)
//                   .trim()
//                   .toLowerCase() ===
//                 String(unitName)
//                   .trim()
//                   .toLowerCase()
//             );

//             return {
//               unit: unitName,
//               qty: oldUnit?.qty ?? "",
//             };
//           });

//         return {
//           ...item,
//           selectedUnits: updatedSelectedUnits,
//         };
//       })
//     );
//   }, [
//     form.SubCategory,
//     subCategories,
//     savedSelectedUnits,
//   ]);

//   const handleProductChange = (index, productId) => {
//     const product = products.find(
//       (p) => String(p._id) === String(productId)
//     );

//     setProductDetails((prev) => {
//       const updated = [...prev];

//       updated[index] = {
//         ...updated[index],
//         productId: productId,
//         units: product?.Units || [],
//         selectedUnits: [],
//       };

//       return updated;
//     });

//     // Product change hone par purane saved units ko hata do
//     setSavedSelectedUnits((prev) =>
//       prev.filter(
//         (item) =>
//           String(item.productId) !== String(productId)
//       )
//     );
//   };

//   const handleNoOfPieceInSheetChange = (index, value) => {
//     setProductDetails((prev) => {
//       const updated = [...prev];

//       updated[index] = {
//         ...updated[index],
//         noOfPieceInSheet: value,
//       };

//       return updated;
//     });
//   };
//   const handleProductDetailChange = (index, field, value) => {
//     const updated = [...productDetails];

//     updated[index][field] = value;

//     setProductDetails(updated);
//   };
//   const handleProductQtyProductChange = (index, productId) => {
//     setProductQtyDetails((prev) => {
//       const updated = [...prev];

//       updated[index] = {
//         ...updated[index],
//         productId,
//       };

//       return updated;
//     });
//   };

//   const handleProductQtyChange = (index, value) => {
//     setProductQtyDetails((prev) => {
//       const updated = [...prev];

//       updated[index] = {
//         ...updated[index],
//         qty: value,
//       };

//       return updated;
//     });
//   };

//   const addProductQtyDetail = () => {
//     setProductQtyDetails((prev) => [
//       ...prev,
//       {
//         productId: "",
//         qty: "",
//       },
//     ]);
//   };

//   const removeProductQtyDetail = (index) => {
//     setProductQtyDetails((prev) =>
//       prev.filter((_, i) => i !== index)
//     );
//   };
//   const handleUnitCheckboxChange = (
//     detailIndex,
//     unit,
//     checked
//   ) => {
//     setProductDetails((prev) => {
//       const updated = [...prev];

//       const currentSelected =
//         updated[detailIndex]?.selectedUnits || [];

//       const unitName =
//         unit?.unitName || unit?.unit;

//       if (!unitName) return prev;

//       if (checked) {
//         // ✅ Already selected hai to dobara add mat karo
//         const alreadyExists = currentSelected.some(
//           (item) => item.unit === unitName
//         );

//         if (alreadyExists) {
//           return prev;
//         }

//         updated[detailIndex] = {
//           ...updated[detailIndex],
//           selectedUnits: [
//             ...currentSelected,
//             {
//               unit: unitName,
//               qty: "",
//             },
//           ],
//         };
//       } else {
//         // ✅ Uncheck hone par remove
//         updated[detailIndex] = {
//           ...updated[detailIndex],
//           selectedUnits: currentSelected.filter(
//             (item) => item.unit !== unitName
//           ),
//         };
//       }

//       return updated;
//     });
//   };
//   const handleSelectedUnitValueChange = (
//     detailIndex,
//     unitName,
//     value
//   ) => {
//     setProductDetails((prev) => {
//       const updated = [...prev];

//       updated[detailIndex] = {
//         ...updated[detailIndex],
//         selectedUnits: (
//           updated[detailIndex].selectedUnits || []
//         ).map((item) =>
//           item.unit === unitName
//             ? {
//               ...item,
//               qty: value,
//             }
//             : item
//         ),
//       };

//       return updated;
//     });
//   };
//   // =========================================================
//   // HANDLE INPUT
//   // =========================================================
//   const handleCostingProduct = (e) => {

//     const productId = e.target.value;

//     setSelectedCostProduct(productId);

//     const selectedProduct =
//       rawProducts.find(
//         (item) => item._id === productId
//       );

//     if (!selectedProduct) return;

//     const newRow = {
//       productId: selectedProduct._id,
//       productName:
//         selectedProduct.Product_Title,
//       purchaseRate:
//         selectedProduct.Purchase_Rate || 0,
//       qty: 1,
//       total:
//         Number(
//           selectedProduct.Purchase_Rate || 0
//         ) * 1,
//     };

//     setCostingRows((prev) => [
//       ...prev,
//       newRow,
//     ]);
//   };

//   const addProductDetail = () => {
//     setProductDetails((prev) => {
//       return [
//         ...prev,
//         {
//           productId: "",
//           units: [],
//           noOfPieceInSheet: "",
//           selectedUnits: [],
//         },
//       ];
//     });
//   };
//   const removeProductDetail = (index) => {
//     setProductDetails((prev) => prev.filter((_, i) => i !== index));
//   };
//   const handleCostingChange = (
//     index,
//     field,
//     value
//   ) => {

//     const updated = [...costingRows];

//     updated[index][field] = value;

//     updated[index].total =
//       Number(updated[index].purchaseRate) *
//       Number(updated[index].qty);

//     setCostingRows(updated);
//   };
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "category") {
//       const selected = categories.find(
//         (c) => c.name === value
//       );

//       setSubCategories(
//         selected?.subcategories || []
//       );
//     }

//     setForm((prev) => ({
//       ...prev,
//       [name]: value,

//       // Final Product nahi hai to steps clear
//       ...(name === "producttype" &&
//         value?.trim()?.toLowerCase() !== "final product"
//         ? { step_Name: [] }
//         : {}),
//     }));
//   };

//   const handleUnitChange = (
//     index,
//     e
//   ) => {

//     const { name, value } = e.target;

//     const updated = [...formValues];

//     updated[index][name] = value;

//     setFormValues(updated);
//   };

//   const addFormFields = () => {

//     setFormValues([
//       ...formValues,
//       {
//         unit: "",
//         qty: "",
//       },
//     ]);
//   };


//   const removeFormFields = (index) => {
//     const updated = [...formValues];
//     const removedUnit = updated[index].unit;

//     updated.splice(index, 1);
//     setFormValues(updated);

//     const stillExists = updated.some(
//       (item) => item.unit === removedUnit
//     );

//     if (!stillExists && stockUnit === removedUnit) {
//       setStockUnit("");
//     }
//   };
//   const handleSubmit = async (e) => {
//     console.log("form.productType =", form.productType);
//     console.log("productId =", productId);
//     console.log("isEdit =", isEdit);
//     console.log("form =", form);
//     if (form.productType === "Child" && !parentProduct) {
//       return swal(
//         "Warning",
//         "Please create Parent Product first.",
//         "warning"
//       );
//     }

//     if (form.productType === "Parent") {
//       const alreadyParent = products.find(
//         (item) =>
//           item.category === form.category &&
//           item.SubCategory === form.SubCategory &&
//           item.productType === "Parent" &&
//           item._id !== productId
//       );
//       if (alreadyParent) {
//         return swal(
//           "Warning",
//           "Parent Product already exists.",
//           "warning"
//         );
//       }
//     }
//     e.preventDefault();

//     try {

//       setLoading(true);

//       const user = JSON.parse(
//         localStorage.getItem("userData")
//       );

//       const formdata = new FormData();
//       console.log("payload ", formdata);

//       // ✅ DEFAULT FIELDS
//       formdata.append(
//         "created_by",
//         user?._id
//       );

//       formdata.append(
//         "database",
//         user?.database
//       );

//       formdata.append(
//         "id",
//         form.Product_Title
//       );

//       // ✅ FORM VALUES
//       Object.entries(form).forEach(([key, value]) => {
//         if (
//           value !== "" &&
//           value !== null &&
//           value !== undefined
//         ) {
//           if (key === "step_Name") {
//             formdata.append(
//               key,
//               JSON.stringify(
//                 Array.isArray(value)
//                   ? value
//                   : value
//                     ? [value]
//                     : []
//               )
//             );
//           } else {
//             formdata.append(key, value);
//           }
//         }
//       });

//       // ✅ UNITS
//       const filteredUnits = formValues.filter(
//         (u) =>
//           u.unit &&
//           u.qty !== "" &&
//           u.qty !== null &&
//           u.qty !== undefined
//       );

//       if (filteredUnits.length > 0) {

//         formdata.append(
//           "Units",
//           JSON.stringify(filteredUnits)
//         );

//       }
//       formdata.append("stockUnit", stockUnit);
//       if (costingRows.length > 0) {

//         formdata.append(
//           "productCosting",
//           JSON.stringify(costingRows)
//         );
//       }
//       const filteredProductDetails = productDetails
//         .filter((item) => item.productId)
//         .map((item) => ({
//           productId:
//             typeof item.productId === "object"
//               ? item.productId._id
//               : item.productId,
//           noOfPieceInSheet: Number(
//             item.noOfPieceInSheet || 0
//           ),
//           selectedUnits: (item.selectedUnits || []).map((unit) => ({
//             unit: unit.unit,
//             qty: Number(unit.qty || 0),
//           })),
//         }));
//       const filteredProductQtyDetails = productQtyDetails
//         .filter(
//           (item) =>
//             item.productId &&
//             item.qty !== "" &&
//             item.qty !== null &&
//             item.qty !== undefined
//         )
//         .map((item) => ({
//           productId: item.productId,
//           qty: Number(item.qty),
//         }));

//       if (filteredProductQtyDetails.length > 0) {
//         formdata.append(
//           "productQtyDetails",
//           JSON.stringify(filteredProductQtyDetails)
//         );
//       }
//       console.log(
//         "FINAL PRODUCT DETAILS =>",
//         JSON.stringify(filteredProductDetails, null, 2)
//       );
//       if (filteredProductDetails.length > 0) {
//         formdata.append(
//           "productDetails",
//           JSON.stringify(filteredProductDetails)
//         );
//       }
//       for (let pair of formdata.entries()) {

//         console.log(pair[0], pair[1]);
//       }
//       // ✅ API
//       // ===============================
//       // EDIT PAYLOAD CHECK
//       // ===============================
//       const editPayload = {};

//       for (let [key, value] of formdata.entries()) {
//         try {
//           editPayload[key] = JSON.parse(value);
//         } catch {
//           editPayload[key] = value;
//         }
//       }

//       console.log(
//         "========== EDIT PAYLOAD =========="
//       );

//       console.log(
//         JSON.stringify(editPayload, null, 2)
//       );

//       console.log(
//         "Product Details =>",
//         editPayload.productDetails
//       );

//       console.log(
//         "Selected Units =>",
//         editPayload.productDetails?.map(
//           (item) => item.selectedUnits
//         )
//       );

//       console.log(
//         "=================================="
//       );


//       if (isEdit) {

//         const res = await _Put(
//           Update_Product,
//           productId,
//           formdata
//         );

//         if (res?.status) {

//           swal(
//             "Success",
//             "Product Updated Successfully",
//             "success"
//           );

//           navigate("/production?view=products");
//         }

//       } else {
//         const res = await SaveProduct(formdata);

//         if (res?.status) {
//           localStorage.removeItem(STORAGE_KEY);
//           swal(
//             "Success",
//             "Product Added Successfully",
//             "success"
//           );

//           navigate("/production?view=products");
//         }
//       }

//     } catch (err) {

//       console.log(
//         "ERROR =>",
//         err?.response?.data
//       );

//       swal(
//         "Error",
//         err?.response?.data?.message ||
//         "Something Went Wrong"
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   const handleBulkUpload = async (e) => {
//     e.preventDefault();

//     const userData = JSON.parse(localStorage.getItem("userData"));

//     if (!BulkImport) {
//       return swal("Please Choose File");
//     }

//     if (!uploadForm?.UploadStatus) {
//       return swal("Choose Type of Upload");
//     }

//     try {
//       setLoading(true);

//       let formdata = new FormData();

//       formdata.append("file", BulkImport);

//       formdata.append("database", userData?.database);

//       // ✅ UPDATE
//       if (uploadForm?.UploadStatus === "Update") {

//         let URL = `${Bulk_Update_Product}/${userData?.database}`;

//         const res = await _BulkUpload(URL, formdata);

//         setLoading(false);

//         if (res?.status) {

//           swal(
//             "Success",
//             "Product Updated Successfully",
//             "success"
//           );

//           navigate("/production?view=products");

//         } else {

//           swal(
//             "Error",
//             "Error In Updating Product",
//             "error"
//           );
//         }
//       }

//       // ✅ NEW UPLOAD
//       else if (
//         uploadForm?.UploadStatus === "New Upload"
//       ) {

//         let URL = `${Bulk_Upload_Product}/${userData?.database}`;
//         const res = await _BulkUpload(URL, formdata);

//         setLoading(false);

//         if (res?.status) {

//           swal(
//             "Success",
//             "Product Added Successfully",
//             "success"
//           );

//           navigate("/production?view=products");

//         } else {

//           swal(
//             "Error",
//             "Error In Adding Product",
//             "error"
//           );
//         }
//       }
//     } catch (err) {

//       setLoading(false);

//       setBulkImport(null);

//       console.log(err?.response);

//       swal(
//         "Error",
//         "Something Went Wrong",
//         "error"
//       );
//     }
//   };

//   // =========================================================
//   // LOADING
//   // =========================================================
//   useEffect(() => {


//     localStorage.setItem(
//       STORAGE_KEY,
//       JSON.stringify({
//         form,
//         formValues,
//         stockUnit
//       })
//     );

//   }, [form, formValues, stockUnit, isEdit]);
//   const parentProduct = products.find(
//     (item) =>
//       item.category === form.category &&
//       item.SubCategory === form.SubCategory &&
//       item.productType === "Parent" &&
//       item._id !== productId
//   );
//   const availableProductTypes = parentProduct
//     ? ["Child"]
//     : ["Parent"];
//   useEffect(() => {
//     if (isEdit) return;
//     if (!form.category || !form.SubCategory) return;

//     if (parentProduct) {
//       setForm((prev) => ({
//         ...prev,
//         productType: "Child",
//       }));
//     } else {
//       setForm((prev) => ({
//         ...prev,
//         productType: "Parent",
//       }));
//     }
//   }, [form.category, form.SubCategory, parentProduct]);



//   useEffect(() => {
//     if (form.productType !== "Child") return;
//     if (!parentProduct) return;

//     setFormValues((prev) =>
//       parentProduct.Units?.map((parentUnit) => {
//         const old = prev.find((x) => x.unit === parentUnit.unit);

//         return {
//           unit: parentUnit.unit,   // Parent ka unit
//           qty: old?.qty || "",     // Child ki qty editable
//         };
//       }) || []
//     );

//     setStockUnit(parentProduct.stockUnit || "");

//     setForm((prev) => ({
//       ...prev,
//       primaryUnit: parentProduct.primaryUnit,
//       secondaryUnit: parentProduct.secondaryUnit,
//       secondarySize: parentProduct.secondarySize,
//     }));
//     console.log("FORM =", form.productType);
//   }, [form.productType, parentProduct]);

//   if (loading) {

//     return (
//       <div
//         style={{
//           textAlign: "center",
//           marginTop: 100,
//         }}
//       >
//         <Spinner />
//       </div>
//     );
//   }
//   const isProduction = form.category === "production";
//   const isSales = form.category === "sales";
//   const isFinalProduct = form.category === "production";
//   return (
//     <div className="erp-page-grid">
//       <Row
//         style={{
//           marginBottom: "15px",
//           alignItems: "center",
//         }}
//       >
//         <Col md="8">
//           <h2>
//             {isEdit
//               ? "Update Product"
//               : "Add Product"}
//           </h2>
//         </Col>

//         {!BulkUpload && (
//           <>
//             <Col md="3" className="text-end">
//               <Button
//                 color="primary"
//                 onClick={() => setBulkUpload(true)}
//               >
//                 Bulk Upload
//               </Button>
//             </Col>

//             <Col md="1">
//               <Button
//                 color="secondary"
//                 onClick={() =>
//                   navigate("/production?view=products")
//                 }
//               >
//                 Back
//               </Button>
//             </Col>
//           </>
//         )}
//       </Row>


//       {BulkUpload ? (
//         <form onSubmit={handleBulkUpload}>

//           <Label>
//             Choose Type of Upload
//             <span style={{ color: "red" }}>
//               *
//             </span>
//           </Label>

//           <Row className="mb-3">
//             <Col md="12">

//               <div>

//                 <input
//                   type="radio"
//                   name="UploadStatus"
//                   value="New Upload"
//                   checked={
//                     uploadForm?.UploadStatus ===
//                     "New Upload"
//                   }
//                   onChange={(e) => {
//                     setUploadForm({
//                       ...uploadForm,
//                       UploadStatus: e.target.value,
//                     });
//                   }}
//                 />

//                 <span className="mx-2">
//                   New Upload
//                 </span>

//                 <input
//                   type="radio"
//                   name="UploadStatus"
//                   value="Update"
//                   checked={
//                     uploadForm?.UploadStatus ===
//                     "Update"
//                   }
//                   onChange={(e) => {
//                     setUploadForm({
//                       ...uploadForm,
//                       UploadStatus: e.target.value,
//                     });
//                   }}
//                 />

//                 <span className="mx-2">
//                   Update
//                 </span>

//               </div>

//             </Col>
//           </Row>

//           <Row>
//             <Col md="4">
//               <label>Bulk Import File</label>

//               <Input
//                 type="file"
//                 required
//                 onChange={(e) =>
//                   setBulkImport(
//                     e.target.files[0]
//                   )
//                 }
//               />
//             </Col>
//           </Row>

//           <div className="mt-3">

//             {!loading ? (
//               <Button
//                 color="primary"
//                 type="submit"
//               >
//                 Import
//               </Button>
//             ) : (
//               <Button color="primary">
//                 Uploading...
//               </Button>
//             )}

//             <Button
//               type="button"
//               color="secondary"
//               className="ms-2"
//               onClick={() =>
//                 setBulkUpload(false)
//               }
//             >
//               Cancel
//             </Button>

//           </div>
//         </form>
//       ) : (


//         <form onSubmit={handleSubmit}>
//           <Row>

//             {/* ================= WAREHOUSE ================= */}

//             <Col md="4">

//               <label>
//                 Warehouse
//               </label>

//               <Input
//                 type="select"
//                 name="warehouse"
//                 value={form.warehouse}
//                 onChange={handleChange}
//               >
//                 <option value="">
//                   Select
//                 </option>

//                 {warehouses.map((w) => (
//                   <option
//                     key={w._id}
//                     value={w._id}
//                   >
//                     {w.warehouseName}
//                   </option>
//                 ))}
//               </Input>

//             </Col>

//             {/* ================= CATEGORY ================= */}

//             <Col md="4">

//               <label>
//                 Category
//               </label>

//               <Input
//                 type="select"
//                 name="category"
//                 value={form.category}
//                 onChange={handleChange}
//               >
//                 <option value="">
//                   Select
//                 </option>

//                 {categories.map((c) => (
//                   <option
//                     key={c._id}
//                     value={c.name}
//                   >
//                     {c.name}
//                   </option>
//                 ))}
//               </Input>

//             </Col>

//             {/* ================= SUB CATEGORY ================= */}

//             <Col md="4">

//               <label>
//                 Sub Category
//               </label>

//               <Input
//                 type="select"
//                 name="SubCategory"
//                 value={form.SubCategory}
//                 onChange={handleChange}
//               >
//                 <option value="">
//                   Select
//                 </option>

//                 {subCategories.map((s, i) => (
//                   <option
//                     key={i}
//                     value={s.name}
//                   >
//                     {s.name}
//                   </option>
//                 ))}
//               </Input>

//             </Col>
//             <Col md="4">
//               <label>Product Type</label>

//               <Input
//                 type="select"
//                 name="productType"
//                 value={form.productType}
//                 onChange={handleChange}
//               >
//                 {availableProductTypes.map((type) => (
//                   <option key={type} value={type}>
//                     {type}
//                   </option>
//                 ))}
//               </Input>
//             </Col>
//             {/* ================= PRODUCT SECTION ================= */}

//             <Col md="4">

//               <label>
//                 Product Section
//               </label>

//               <Input
//                 type="select"
//                 name="producttype"
//                 value={form.producttype}
//                 onChange={handleChange}
//               >
//                 <option value="">
//                   Select Product Section
//                 </option>

//                 {productSections.map((item) => (
//                   <option
//                     key={item._id}
//                     value={item.producttype}
//                   >
//                     {item.producttype}
//                   </option>
//                 ))}
//                 <option value="wastage">wastage</option>

//               </Input>

//             </Col>
//             {!isSales &&
//               form.producttype?.trim()?.toLowerCase() === "final product" && (
//                 <Col md="4">
//                   <label className="mb-1">Product Step</label>

//                   {/* Selected Steps - upar show honge */}
//                   {Array.isArray(form.step_Name) &&
//                     form.step_Name.length > 0 && (
//                       <div className="d-flex flex-wrap gap-2 mb-2">
//                         {form.step_Name.map((stepName) => (
//                           <span
//                             key={stepName}
//                             className="badge bg-primary d-flex align-items-center"
//                             style={{
//                               fontSize: "13px",
//                               padding: "7px 10px",
//                             }}
//                           >
//                             {stepName}

//                             <span
//                               onClick={() => {
//                                 setForm((prev) => ({
//                                   ...prev,
//                                   step_Name: prev.step_Name.filter(
//                                     (name) => name !== stepName
//                                   ),
//                                 }));
//                               }}
//                               style={{
//                                 cursor: "pointer",
//                                 marginLeft: "8px",
//                                 fontWeight: "bold",
//                                 fontSize: "15px",
//                               }}
//                             >
//                               ×
//                             </span>
//                           </span>
//                         ))}
//                       </div>
//                     )}

//                   {/* Step Dropdown / Checkbox List */}
//                   <div
//                     className="border rounded p-2"
//                     style={{
//                       maxHeight: "150px",
//                       overflowY: "auto",
//                     }}
//                   >
//                     {productstep?.map((item) =>
//                       item?.steps?.map((step) => {
//                         const stepName = step?.step_Name;

//                         const isChecked =
//                           Array.isArray(form.step_Name) &&
//                           form.step_Name.includes(stepName);

//                         return (
//                           <div
//                             key={step?._id || stepName}
//                             className="form-check mb-1"
//                           >
//                             <Input
//                               type="checkbox"
//                               className="form-check-input"
//                               id={`step-${step?._id || stepName}`}
//                               checked={isChecked}
//                               onChange={(e) => {
//                                 const checked = e.target.checked;

//                                 setForm((prev) => {
//                                   const currentSteps = Array.isArray(
//                                     prev.step_Name
//                                   )
//                                     ? prev.step_Name
//                                     : [];

//                                   if (checked) {
//                                     return {
//                                       ...prev,
//                                       step_Name: currentSteps.includes(stepName)
//                                         ? currentSteps
//                                         : [...currentSteps, stepName],
//                                     };
//                                   }

//                                   return {
//                                     ...prev,
//                                     step_Name: currentSteps.filter(
//                                       (name) => name !== stepName
//                                     ),
//                                   };
//                                 });
//                               }}
//                             />

//                             <label
//                               className="form-check-label ms-2"
//                               htmlFor={`step-${step?._id || stepName}`}
//                               style={{
//                                 cursor: "pointer",
//                               }}
//                             >
//                               {stepName}
//                             </label>
//                           </div>
//                         );
//                       })
//                     )}

//                     {(!productstep ||
//                       productstep.length === 0 ||
//                       !productstep.some(
//                         (item) => item?.steps?.length > 0
//                       )) && (
//                         <div className="text-muted">
//                           No Product Steps Found
//                         </div>
//                       )}
//                   </div>
//                 </Col>
//               )}

//             {/* ================= PRODUCT NAME ================= */}

//             <Col md="4">

//               <label>
//                 Product Name
//               </label>

//               <Input
//                 name="Product_Title"
//                 value={form.Product_Title}
//                 onChange={handleChange}
//                 required
//               />

//             </Col>

//             {/* ================= HSN ================= */}

//             {!isProduction && (
//               <Col md="4">

//                 <label>
//                   HSN Code
//                 </label>

//                 <Input
//                   name="HSN_Code"
//                   value={form.HSN_Code}
//                   onChange={handleChange}
//                 />

//               </Col>
//             )}

//             {/* ================= GST ================= */}

//             {!isProduction && (
//               <Col md="4">

//                 <label>
//                   GST %
//                 </label>

//                 <Input
//                   type="number"
//                   name="GSTRate"
//                   value={form.GSTRate}
//                   onChange={handleChange}
//                 />

//               </Col>
//             )}

//             {/* ================= OPENING STOCK ================= */}

//             <Col md="4">

//               <label>
//                 Opening Stock
//               </label>

//               <Input
//                 type="number"
//                 name="Opening_Stock"
//                 value={form.Opening_Stock}
//                 onChange={handleChange}
//               />

//             </Col>

//             {/* ================= OPENING PRICE ================= */}

//             {(
//               <Col md="4">

//                 <label>
//                   Opening Price
//                 </label>

//                 <Input
//                   type="number"
//                   name="openingRate"
//                   value={form.openingRate}
//                   onChange={handleChange}
//                 />

//               </Col>
//             )}

//             {/* ================= PRIMARY UNIT ================= */}

//             <Col md="4">

//               <label>
//                 Primary Unit
//               </label>

//               <Input
//                 type="select"
//                 name="primaryUnit"
//                 value={form.primaryUnit}
//                 onChange={handleChange}
//               >
//                 <option value="">
//                   Select
//                 </option>

//                 {units.map((u, i) => (
//                   <option
//                     key={i}
//                     value={u.unitName}
//                   >
//                     {u.unitName}
//                   </option>
//                 ))}

//               </Input>

//             </Col>

//             {/* ================= SECONDARY UNIT ================= */}


//             <Col md="4">

//               <label>
//                 Secondary Unit
//               </label>

//               <Input
//                 type="select"
//                 name="secondaryUnit"
//                 value={form.secondaryUnit}
//                 onChange={handleChange}
//               >
//                 <option value="">
//                   Select
//                 </option>

//                 {units.map((u, i) => (
//                   <option
//                     key={i}
//                     value={u.unitName}
//                   >
//                     {u.unitName}
//                   </option>
//                 ))}

//               </Input>

//             </Col>


//             {/* ================= SECONDARY QTY ================= */}



//             <Col md="4">

//               <label>
//                 Secondary Qty
//               </label>

//               <Input
//                 type="number"
//                 name="secondarySize"
//                 value={form.secondarySize}
//                 onChange={handleChange}
//               />

//             </Col>


//             {/* ================= MIN STOCK ALERT ================= */}

//             <Col md="4">

//               <label>
//                 Min Stock Alert
//               </label>

//               <Input
//                 type="number"
//                 name="MIN_stockalert"
//                 value={form.MIN_stockalert}
//                 onChange={handleChange}
//               />

//             </Col>
//             <Col md="4">

//               <label>
//                 Purchase Rate
//               </label>

//               <Input
//                 type="number"
//                 name="Purchase_Rate"
//                 value={form.Purchase_Rate}
//                 onChange={handleChange}
//               />

//             </Col>
//             {isEdit && (
//               <Col md="4">
//                 <label>Landed Cost</label>

//                 <Input
//                   type="number"
//                   name="landedCost"
//                   value={form.landedCost}
//                   readOnly
//                 />
//               </Col>
//             )}
//             <Row>

//               {/* LEFT SIDE */}
//               {!isSales && (
//                 <Col md="6">

//                   {/* ====== Units Heading ====== */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                       marginBottom: "5px",
//                     }}
//                   >
//                     <label style={{ marginBottom: 0 }}>Units</label>

//                     <Button
//                       color="primary"
//                       type="button"
//                       style={{
//                         padding: "2px 5px",
//                         fontSize: "10px",
//                         lineHeight: "1",
//                       }}
//                       onClick={() =>
//                         navigate("/production?view=units")
//                       }
//                     >
//                       +
//                     </Button>
//                   </div>

//                   {/* ====== Units ====== */}
//                   {formValues.map((element, index) => (
//                     <Row key={index} className="mt-1">

// <Col md="5">
//   <Input
//     type="select"
//     name="unit"
//     value={element.unit}
//     disabled={form.productType === "Child"}
//     onChange={(e) =>
//       handleUnitChange(index, e)
//     }
//   >
//     <option value="">Select Unit</option>

//     {units.map((u) => (
//       <option
//         key={u._id}
//         value={u.unitId}
//       >
//         {u.unitName}
//       </option>
//     ))}
//   </Input>
// </Col>

// <Col md="5">
//   <Input
//     type="number"
//     name="qty"
//     value={element.qty}
//     placeholder="Qty"
//     onChange={(e) =>
//       handleUnitChange(index, e)
//     }
//   />
// </Col>

//                       <Col md="2">

//                         {index === 0 ? (
//                           <Button
//                             color="primary"
//                             disabled={form.productType === "Child"}
//                             onClick={addFormFields}
//                           >
//                             +
//                           </Button>
//                         ) : (
//                           <Button
//                             color="danger"
//                             disabled={form.productType === "Child"}
//                             onClick={() =>
//                               removeFormFields(index)
//                             }
//                           >
//                             ×
//                           </Button>
//                         )}

//                       </Col>

//                     </Row>
//                   ))}

//                   {/* ===== Stock Unit ===== */}
//                   <Row className="mt-2">

//                     <Col md="6">

//                       <Label>Stock Unit</Label>

//                       <Input
//                         type="select"
//                         value={stockUnit}
//                         disabled={form.productType === "Child"}
//                         onChange={(e) =>
//                           setStockUnit(e.target.value)
//                         }
//                       >
//                         <option value="">
//                           Select Stock Unit
//                         </option>

//                         {formValues
//                           .filter((x) => x.unit)
//                           .map((x, i) => {
//                             const unitObj = units.find(
//                               (u) => u.unitId === x.unit
//                             );

//                             return (
//                               <option
//                                 key={i}
//                                 value={x.unit}
//                               >
//                                 {unitObj?.unitName}
//                               </option>
//                             );
//                           })}
//                       </Input>

//                     </Col>

//                   </Row>

//                 </Col>
//               )}

//               {form.producttype?.trim()?.toLowerCase() === "final product" && (
//                 <Col md="6">

//                   <div className="d-flex justify-content-between align-items-center mt-3 mb-2">

//                     <h5>Final Product Details</h5>

//                     <Button
//                       color="primary"
//                       size="sm"
//                       type="button"
//                       onClick={addProductDetail}
//                     >
//                       + Add More
//                     </Button>

//                   </div>

//                   {productDetails?.map((item, index) => (

//                     <div
//                       className="border rounded p-3 mb-3"
//                       key={index}
//                     >

//                       {/* REMOVE BUTTON */}
//                       {productDetails.length > 1 && (
//                         <div className="text-end mb-2">

//                           <Button
//                             color="danger"
//                             size="sm"
//                             type="button"
//                             onClick={() =>
//                               removeProductDetail(index)
//                             }
//                           >
//                             Remove
//                           </Button>

//                         </div>
//                       )}

//                       <Row>

//                         {/* ================= PRODUCT ================= */}

//                         <Col md="6">

//                           <Label>Product</Label>

//                           <Input
//                             type="select"
//                             value={item.productId || ""}
//                             onChange={(e) =>
//                               handleProductChange(
//                                 index,
//                                 e.target.value
//                               )
//                             }
//                           >
//                             <option value="">
//                               Select Product
//                             </option>

//                             {products.map((p) => (
//                               <option
//                                 key={p._id}
//                                 value={p._id}
//                               >
//                                 {p.Product_Title}
//                               </option>
//                             ))}

//                           </Input>
//                           {/* ================= NO. OF PIECE IN SHEET ================= */}

//                           <div className="mt-3">
//                             <Label>No. of Piece in Sheet</Label>

//                             <Input
//                               type="number"
//                               min="0"
//                               value={
//                                 productQtyDetails.find((p) => {
//                                   const selectedProductId =
//                                     typeof item.productId === "object"
//                                       ? item.productId?._id
//                                       : item.productId;

//                                   const qtyProductId =
//                                     typeof p.productId === "object"
//                                       ? p.productId?._id
//                                       : p.productId;

//                                   return (
//                                     String(selectedProductId) ===
//                                     String(qtyProductId)
//                                   );
//                                 })?.qty ?? ""
//                               }
//                               placeholder="No. of Piece in Sheet"
//                               onChange={(e) => {
//                                 const value = e.target.value;

//                                 const selectedProductId =
//                                   typeof item.productId === "object"
//                                     ? item.productId?._id
//                                     : item.productId;

//                                 setProductQtyDetails((prev) => {
//                                   const exists = prev.some((p) => {
//                                     const qtyProductId =
//                                       typeof p.productId === "object"
//                                         ? p.productId?._id
//                                         : p.productId;

//                                     return String(selectedProductId) === String(qtyProductId);
//                                   });

//                                   if (exists) {
//                                     return prev.map((p) => {
//                                       const qtyProductId =
//                                         typeof p.productId === "object"
//                                           ? p.productId?._id
//                                           : p.productId;

//                                       if (
//                                         String(selectedProductId) ===
//                                         String(qtyProductId)
//                                       ) {
//                                         return {
//                                           ...p,
//                                           qty: value,
//                                         };
//                                       }

//                                       return p;
//                                     });
//                                   }

//                                   return [
//                                     ...prev,
//                                     {
//                                       productId: selectedProductId,
//                                       qty: value,
//                                     },
//                                   ];
//                                 });
//                               }}
//                             />
//                           </div>
//                         </Col>


//                         {/* ================= UNITS ================= */}

//                         {item.productId && item.units?.length > 0 && (

//                           <Col md="6">
//                             <Label>Units</Label>

//                             <table className="table table-bordered table-sm mb-0">
//                               <tbody>
//                                 {item.units?.map((u, i) => (
//                                   <tr key={i}>
//                                     <td>{u.unit}</td>
//                                     <td>{u.qty}</td>
//                                   </tr>
//                                 ))}
//                               </tbody>
//                             </table>
//                           </Col>

//                         )}




//                         {form.SubCategory && (
//                           <Col md="12" className="mt-3">

//                             <Label>Units</Label>

//                             <Row>

//                               {item.selectedUnits?.map(
//                                 (selectedUnit, selectedIndex) => (
//                                   <Col
//                                     md="4"
//                                     key={selectedIndex}
//                                     className="mb-2"
//                                   >

//                                     <div
//                                       className="d-flex align-items-center"
//                                       style={{
//                                         gap: "8px",
//                                       }}
//                                     >

//                                       {/* UNIT NAME */}
//                                       <span
//                                         style={{
//                                           minWidth: "80px",
//                                           fontWeight: 500,
//                                         }}
//                                       >
//                                         {selectedUnit.unit}
//                                       </span>

//                                       {/* VALUE */}
//                                       <Input
//                                         type="number"
//                                         value={selectedUnit.qty || ""}
//                                         placeholder="Value"
//                                         onChange={(e) =>
//                                           handleSelectedUnitValueChange(
//                                             index,
//                                             selectedUnit.unit,
//                                             e.target.value
//                                           )
//                                         }
//                                       />

//                                     </div>

//                                   </Col>
//                                 )
//                               )}

//                             </Row>

//                           </Col>
//                         )}





//                         {/* ================= NO UNITS ================= */}

//                         {item.productId &&
//                           (!item.units ||
//                             item.units.length === 0) && (

//                             <Col md="12" className="mt-3">

//                               <div className="text-danger">
//                                 No units found for this product.
//                               </div>

//                             </Col>

//                           )}

//                       </Row>

//                     </div>

//                   ))}

//                 </Col>
//               )}


//               {form.producttype?.trim()?.toLowerCase() !== "final product" && (
//                 <Col md="6" className="mt-3">

//                   <div
//                     className="d-flex align-items-center mb-2"
//                     style={{ gap: "10px" }}
//                   >



//                   </div>

//                   {productQtyDetails.map((item, index) => (
//                     <Row
//                       key={index}
//                       className="mb-2 align-items-end"
//                     >
//                     </Row>
//                   ))}

//                 </Col>
//               )}
//             </Row>
//             {/* ================= PRODUCT COSTING ================= */}

//             {isFinalProduct && (

//               <>

//                 <Col md="4">

//                   <label>
//                     Product Costing
//                   </label>

//                   <Input
//                     type="select"
//                     value={selectedCostProduct}
//                     onChange={handleCostingProduct}
//                   >

//                     <option value="">
//                       Select Raw Material
//                     </option>

//                     {rawProducts.map((item) => (

//                       <option
//                         key={item._id}
//                         value={item._id}
//                       >
//                         {item.Product_Title}
//                       </option>

//                     ))}

//                   </Input>

//                 </Col>

//                 {costingRows.length > 0 && (

//                   <Col md="12" className="mt-3">

//                     <table className="table table-bordered">

//                       <thead>

//                         <tr>
//                           <th>Product Name</th>
//                           <th>Purchase Rate</th>
//                           <th>Qty</th>
//                           <th>Total</th>
//                         </tr>

//                       </thead>

//                       <tbody>

//                         {costingRows.map(
//                           (row, index) => (

//                             <tr key={index}>

//                               <td>
//                                 {row.productName}
//                               </td>

//                               <td>

//                                 <Input
//                                   type="number"
//                                   value={row.purchaseRate}
//                                   onChange={(e) =>
//                                     handleCostingChange(
//                                       index,
//                                       "purchaseRate",
//                                       e.target.value
//                                     )
//                                   }
//                                 />

//                               </td>

//                               <td>

//                                 <Input
//                                   type="number"
//                                   value={row.qty}
//                                   onChange={(e) =>
//                                     handleCostingChange(
//                                       index,
//                                       "qty",
//                                       e.target.value
//                                     )
//                                   }
//                                 />

//                               </td>

//                               <td>
//                                 {row.total}
//                               </td>

//                             </tr>

//                           )
//                         )}

//                       </tbody>

//                     </table>

//                   </Col>

//                 )}

//               </>

//             )}
//           </Row>

//           <br />

//           <Button
//             color="primary"
//             type="submit"
//           >
//             {isEdit ? "Update Product" : "Save Product"}
//           </Button>

//         </form>
//       )}
//     </div>
//   );
// }
























import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Spinner,
  Input,
  Row,
  Col,
  Label,
  FormGroup,
} from "reactstrap";

import { useNavigate } from "react-router-dom";

import swal from "sweetalert";

import {
  SaveProduct,
  AllCategoryList,
  _GetByUrl,
  _BulkUpload,
  _Put,
} from "../../ApiEndPoint/ApiCalling";

import {
  Bulk_Update_Product,
  Bulk_Upload_Product,
  Update_Product,
  viewUnits,
} from "../../ApiEndPoint/Api";

import axiosConfig from "../../AxiosConfig";
import { useSearchParams } from "react-router-dom";

export default function AddProduct() {
  const [showStepDropdown, setShowStepDropdown] = useState(false);
  const stepDropdownRef = useRef(null);

  const STORAGE_KEY = "add_product_form";
  const [productionItemType, setProductionItemType] = useState("");
  const [searchParams] = useSearchParams();

  const view = searchParams.get("view");

  const isEdit = view?.includes("edit-product");

  const productId = view?.split("edit-product-")[1];

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  // =========================================================
  // BULK UPLOAD
  // =========================================================

  const [BulkUpload, setBulkUpload] = useState(false);
  const [BulkImport, setBulkImport] = useState(null);

  const [uploadForm, setUploadForm] = useState({
    UploadStatus: "",
  });

  // =========================================================
  // MASTER DATA
  // =========================================================

  const [warehouses, setWarehouses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [units, setUnits] = useState([]);
  const [productstep, setProductStep] = useState([]);
  const [rawProducts, setRawProducts] = useState([]);
  const [products, setProducts] = useState([]);

  // =========================================================
  // PRODUCT SECTION
  // =========================================================

  const [productSection, setProductSection] = useState("");

  // =========================================================
  // FINAL PRODUCT SPECIFICATION
  // =========================================================

  const emptySpecification = () => ({
    netQty: "",
    netSqInch: "",
    netWeight: "",
    grossQty: "",
    grossSqInch: "",
    grossWeight: "",
    qtyInBundle: "",
    qtyInBag: "",
    noOfBundleInBag: "",
    weightOfBundle: "",
    weightOfBag: "",
    wastageSqInch: "",
    wastageWeight: "",
  });

  const [productSpecification, setProductSpecification] =
    useState([emptySpecification()]);

  // =========================================================
  // PRODUCTION RAW MATERIAL
  // =========================================================

  const emptyProductionMaterial = () => ({
    productId: "",
    qtyRequired: "",
    basicPrice: "",
    total: 0,
  });

  const [productionMaterials, setProductionMaterials] =
    useState([emptyProductionMaterial()]);

  // =========================================================
  // PRODUCTION UNITS
  // =========================================================
  const emptyProductionUnit = () => ({
    grossQty: "",
    grossSqInch: "",
    grossWeight: "",
  });

  const [productionUnits, setProductionUnits] = useState([
    emptyProductionUnit(),
  ]);


  const [form, setForm] = useState({
    type: "Trading",

    Product_Title: "",

    Product_MRP: "",

    step_Name: [],

    openingRate: "",

    Purchase_Rate: "",
    grossQty: "",
    grossSqInch: "",
    grossWeight: "",
    purchaseRatePerGrossSqInch: "",

    HSN_Code: "",

    GSTRate: "",

    gstType: "",

    Opening_Stock: "",

    MIN_stockalert: "",

    landedCost: "",

    category: "",

    SubCategory: "",

    warehouse: "",

    primaryUnit: "",

    secondaryUnit: "",

    secondarySize: "",

    status: "Active",

    productType: "Parent",
  });

  // =========================================================
  // FLAGS
  // =========================================================
  // =========================================================
  // AUTO CALCULATE PURCHASE RATE / GROSS SQ INCH
  // =========================================================

  useEffect(() => {
    const purchaseRate = Number(form.Purchase_Rate || 0);
    const grossSqInch = Number(form.grossSqInch || 0);

    const calculatedValue =
      grossSqInch > 0
        ? (purchaseRate / grossSqInch).toFixed(2)
        : "";

    setForm((prev) => {
      if (
        prev.purchaseRatePerGrossSqInch === calculatedValue
      ) {
        return prev;
      }

      return {
        ...prev,
        purchaseRatePerGrossSqInch: calculatedValue,
      };
    });
  }, [form.Purchase_Rate, form.grossSqInch]);
  const isProduction =
    String(form.type || "")
      .trim()
      .toLowerCase() === "production";

  const isTrading =
    String(form.type || "")
      .trim()
      .toLowerCase() === "trading";

  const isFinalProduct =
    isProduction &&
    productSection === "Final Product";

  const isProductionSection =
    isProduction &&
    productSection === "Production";

  // =========================================================
  // LOCAL STORAGE RESTORE
  // =========================================================

  useEffect(() => {
    if (!isEdit) {
      const savedData =
        localStorage.getItem(STORAGE_KEY);

      if (savedData) {
        try {
          const parsed =
            JSON.parse(savedData);

          if (parsed?.form) {
            setForm((prev) => ({
              ...prev,
              ...parsed.form,

              type:
                parsed.form.type ||
                "Production",

              gstType:
                parsed.form.gstType ||
                "",
            }));
          }

          if (parsed?.productSection) {
            setProductSection(
              parsed.productSection
            );
          }

          if (
            Array.isArray(
              parsed?.productSpecification
            ) &&
            parsed.productSpecification.length > 0
          ) {
            setProductSpecification(
              parsed.productSpecification
            );
          }

          if (
            Array.isArray(
              parsed?.productionMaterials
            ) &&
            parsed.productionMaterials.length > 0
          ) {
            setProductionMaterials(
              parsed.productionMaterials
            );
          }
          if (
            Array.isArray(parsed?.productionUnits) &&
            parsed.productionUnits.length > 0
          ) {
            setProductionUnits(
              parsed.productionUnits
            );
          }
        } catch (error) {
          console.log(
            "LOCAL STORAGE RESTORE ERROR =>",
            error
          );
        }
      }
    }
  }, [isEdit]);

  // =========================================================
  // EDIT PRODUCT
  // =========================================================

  useEffect(() => {
    if (
      isEdit &&
      productId

    ) {
      getSingleProduct();
    }
  }, [
    isEdit,

    products,
  ]);



  //   const getSingleProduct = async () => {
  //     try {
  //       setLoading(true);

  //       const res = await axiosConfig.get(
  //         `/product/view-product-by-id/${productId}`
  //       );

  //       const data = res?.data?.Product;
  // debugger
  //       console.log("========== EDIT PRODUCT DATA ==========");
  //       console.log(data);
  //       console.log("PRODUCT SECTION FROM API =>", data?.productSection);
  //       // ================= PRODUCT SECTION =================
  //       const savedSection = String(
  //         data?.productSection ||
  //         data?.ProductSection ||
  //         data?.product_section ||
  //         ""
  //       )
  //         .trim()
  //         .toLowerCase();

  //       let editProductSection = "";

  //       if (savedSection === "final product") {
  //         editProductSection = "Final Product";
  //       } else if (savedSection === "production") {
  //         editProductSection = "Production";
  //       }

  //       console.log(
  //         "NORMALIZED PRODUCT SECTION =>",
  //         editProductSection
  //       );

  //       setProductSection(editProductSection);

  //       // ================= FORM =================
  //       setForm({
  //         type: data?.type || "Production",

  //         Product_Title:
  //           data?.Product_Title || "",

  //         Product_MRP:
  //           data?.Product_MRP ?? "",

  //         Purchase_Rate:
  //           data?.Purchase_Rate ?? "",

  //         HSN_Code:
  //           data?.HSN_Code || "",

  //         GSTRate:
  //           data?.GSTRate ?? "",

  //         gstType:
  //           data?.gstType || "",

  //         Opening_Stock:
  //           data?.Opening_Stock ?? "",

  //         MIN_stockalert:
  //           data?.MIN_stockalert ?? "",

  //         landedCost:
  //           data?.landedCost ??
  //           data?.Purchase_Rate ??
  //           "",

  //         category:
  //           data?.category || "",

  //         SubCategory:
  //           data?.SubCategory || "",

  //         warehouse:
  //           typeof data?.warehouse === "object"
  //             ? data?.warehouse?._id ||
  //             data?.warehouse?.id ||
  //             ""
  //             : data?.warehouse || "",

  //         openingRate:
  //           data?.openingRate ?? "",

  //         primaryUnit:
  //           data?.primaryUnit || "",

  //         secondaryUnit:
  //           data?.secondaryUnit || "",

  //         secondarySize:
  //           data?.secondarySize ?? "",

  //         step_Name:
  //           Array.isArray(data?.step_Name)
  //             ? data.step_Name
  //             : data?.step_Name
  //               ? [data.step_Name]
  //               : [],

  //         productType:
  //           data?.productType || "Parent",

  //         status:
  //           data?.status || "Active",
  //       });

  //       // ================= PRODUCT SPECIFICATION =================
  //       let savedSpecification =
  //         data?.productSpecification;

  //       if (typeof savedSpecification === "string") {
  //         try {
  //           savedSpecification =
  //             JSON.parse(savedSpecification);
  //         } catch (error) {
  //           console.log(
  //             "SPECIFICATION PARSE ERROR =>",
  //             error
  //           );

  //           savedSpecification = [];
  //         }
  //       }

  //       if (
  //         Array.isArray(savedSpecification) &&
  //         savedSpecification.length > 0
  //       ) {
  //         setProductSpecification(
  //           savedSpecification.map((item) => ({
  //             netQty: item?.netQty ?? "",
  //             netSqInch: item?.netSqInch ?? "",
  //             netWeight: item?.netWeight ?? "",
  //             grossQty: item?.grossQty ?? "",
  //             grossSqInch: item?.grossSqInch ?? "",
  //             grossWeight: item?.grossWeight ?? "",
  //             qtyInBundle: item?.qtyInBundle ?? "",
  //             qtyInBag: item?.qtyInBag ?? "",
  //             noOfBundleInBag:
  //               item?.noOfBundleInBag ?? "",
  //             weightOfBundle:
  //               item?.weightOfBundle ?? "",
  //             weightOfBag:
  //               item?.weightOfBag ?? "",
  //             wastageSqInch:
  //               item?.wastageSqInch ?? "",
  //             wastageWeight:
  //               item?.wastageWeight ?? "",
  //           }))
  //         );
  //       } else {
  //         setProductSpecification([
  //           emptySpecification(),
  //         ]);
  //       }

  //       // ================= PRODUCTION MATERIALS =================
  //       let savedProductionMaterials =
  //         data?.productionMaterials;

  //       if (
  //         typeof savedProductionMaterials === "string"
  //       ) {
  //         try {
  //           savedProductionMaterials =
  //             JSON.parse(
  //               savedProductionMaterials
  //             );
  //         } catch (error) {
  //           console.log(
  //             "PRODUCTION MATERIAL PARSE ERROR =>",
  //             error
  //           );

  //           savedProductionMaterials = [];
  //         }
  //       }

  //       console.log(
  //         "EDIT PRODUCTION MATERIALS =>",
  //         savedProductionMaterials
  //       );

  //       if (
  //         Array.isArray(savedProductionMaterials) &&
  //         savedProductionMaterials.length > 0
  //       ) {
  //         setProductionMaterials(
  //           savedProductionMaterials.map((item) => {
  //             const qty = Number(
  //               item?.qtyRequired ?? 0
  //             );

  //             const price = Number(
  //               item?.basicPrice ?? 0
  //             );

  //             return {
  //               productId:
  //                 item?.productId || "",

  //               qtyRequired:
  //                 item?.qtyRequired ?? "",

  //               basicPrice:
  //                 item?.basicPrice ?? "",

  //               total:
  //                 item?.total ??
  //                 qty * price,
  //             };
  //           })
  //         );
  //       } else if (
  //         editProductSection === "Production" &&
  //         data?.id
  //       ) {
  //         // Agar old data me productionMaterials nahi hai
  //         // lekin id me raw material saved hai
  //         setProductionMaterials([
  //           {
  //             productId:
  //               typeof data.id === "object"
  //                 ? data.id?._id || ""
  //                 : data.id || "",

  //             qtyRequired: "",
  //             basicPrice: "",
  //             total: 0,
  //           },
  //         ]);
  //         // ================= PRODUCTION UNITS =================

  //         let savedProductionUnits =
  //           data?.Units;

  //         if (
  //           typeof savedProductionUnits === "string"
  //         ) {
  //           try {
  //             savedProductionUnits =
  //               JSON.parse(savedProductionUnits);
  //           } catch (error) {
  //             console.log(
  //               "PRODUCTION UNITS PARSE ERROR =>",
  //               error
  //             );

  //             savedProductionUnits = [];
  //           }
  //         }


  //         if (
  //           Array.isArray(savedProductionUnits) &&
  //           savedProductionUnits.length > 0
  //         ) {
  //           setProductionUnits(
  //             savedProductionUnits.map((item) => ({
  //               grossQty: item?.grossQty ?? "",
  //               grossSqInch: item?.grossSqInch ?? "",
  //               grossWeight: item?.grossWeight ?? "",
  //             }))
  //           );
  //         } else {
  //           setProductionUnits([
  //             emptyProductionUnit(),
  //           ]);
  //         }
  //       }
  //       else {
  //         setProductionMaterials([
  //           emptyProductionMaterial(),
  //         ]);
  //       }
  //     } catch (err) {
  //       console.log(
  //         "EDIT PRODUCT ERROR =>",
  //         err
  //       );

  //       console.log(
  //         "EDIT PRODUCT RESPONSE =>",
  //         err?.response?.data
  //       );
  //     } finally {
  //       setLoading(false);
  //     }
  //   };




  // =========================================================
  // STEP DROPDOWN OUTSIDE CLICK
  // =========================================================


  const getSingleProduct = async () => {
    try {
      setLoading(true);

      const res = await axiosConfig.get(
        `/product/view-product-by-id/${productId}`
      );

      const data = res?.data?.Product;
      console.log("========== EDIT PRODUCT DATA ==========");
      console.log(data);

      // ================= PRODUCT SECTION =================
      const savedSection = String(
        data?.productSection ||
        data?.ProductSection ||
        data?.product_section ||
        ""
      )
        .trim()
        .toLowerCase();

      let editProductSection = "";

      if (savedSection === "final product") {
        editProductSection = "Final Product";
      } else if (savedSection === "production") {
        editProductSection = "Production";
      }

      console.log(
        "NORMALIZED PRODUCT SECTION =>",
        editProductSection
      );

      setProductSection(editProductSection);

      // ================= FORM =================
      setForm({
        type: data?.type || "Production",

        Product_Title: data?.Product_Title || "",

        Product_MRP: data?.Product_MRP ?? "",
        Purchase_Rate: data?.Purchase_Rate ?? "",
       grossQty: data?.Units?.[0]?.grossQty ?? "",
grossSqInch: data?.Units?.[0]?.grossSqInch ?? "",
grossWeight: data?.Units?.[0]?.grossWeight ?? "",
        purchaseRatePerGrossSqInch:
          data?.purchaseRatePerGrossSqInch ?? "",
          gstType: data?.gstType || data?.GSTType || "",
        HSN_Code: data?.HSN_Code || "",
        GSTRate: data?.GSTRate ?? "",
        gstType: data?.gstType || "",

        Opening_Stock: data?.Opening_Stock ?? "",
        MIN_stockalert: data?.MIN_stockalert ?? "",

        landedCost:
          data?.landedCost ??
          data?.Purchase_Rate ??
          "",

        category: data?.category || "",
        SubCategory: data?.SubCategory || "",

        warehouse:
          typeof data?.warehouse === "object"
            ? data?.warehouse?._id ||
            data?.warehouse?.id ||
            ""
            : data?.warehouse || "",

        openingRate: data?.openingRate ?? "",

        primaryUnit: data?.primaryUnit || "",
        secondaryUnit: data?.secondaryUnit || "",
        secondarySize: data?.secondarySize ?? "",

        step_Name: data?.current_Step
  ? [data.current_Step]
  : [],
        productType: data?.productType || "Parent",
        status: data?.status || "Active",
      });
      setProductionItemType(
  data?.productionItemType || ""
);
const matchedStep = productstep.find(
  (step) =>
    String(step?.step_Name).toLowerCase() ===
    String(data?.current_Step || "").toLowerCase()
);

setForm((prev) => ({
  ...prev,
  step_Name: matchedStep ? [matchedStep._id] : [],
}));
      // ================= PRODUCT SPECIFICATION =================
      let savedSpecification = data?.productSpecification;

      if (typeof savedSpecification === "string") {
        try {
          savedSpecification = JSON.parse(savedSpecification);
        } catch (error) {
          console.log("SPECIFICATION PARSE ERROR =>", error);
          savedSpecification = [];
        }
      }

      if (
        Array.isArray(savedSpecification) &&
        savedSpecification.length > 0
      ) {
        setProductSpecification(
          savedSpecification.map((item) => ({
            netQty: item?.netQty ?? "",
            netSqInch: item?.netSqInch ?? "",
            netWeight: item?.netWeight ?? "",

            grossQty: item?.grossQty ?? "",
            grossSqInch: item?.grossSqInch ?? "",
            grossWeight: item?.grossWeight ?? "",

            qtyInBundle: item?.qtyInBundle ?? "",
            qtyInBag: item?.qtyInBag ?? "",
            noOfBundleInBag: item?.noOfBundleInBag ?? "",

            weightOfBundle: item?.weightOfBundle ?? "",
            weightOfBag: item?.weightOfBag ?? "",

            wastageSqInch: item?.wastageSqInch ?? "",
            wastageWeight: item?.wastageWeight ?? "",
          }))
        );
      } else {
        setProductSpecification([emptySpecification()]);
      }

      // ================= PRODUCTION MATERIALS =================
      let savedProductionMaterials = data?.productionMaterials;

      if (typeof savedProductionMaterials === "string") {
        try {
          savedProductionMaterials = JSON.parse(
            savedProductionMaterials
          );
        } catch (error) {
          console.log(
            "PRODUCTION MATERIAL PARSE ERROR =>",
            error
          );

          savedProductionMaterials = [];
        }
      }

      // New format:
      // { materials: [...], grandTotal: 150 }
      // Old format:
      // [...]

      let materialsArray = [];

      if (Array.isArray(savedProductionMaterials)) {
        materialsArray = savedProductionMaterials;
      } else if (
        savedProductionMaterials &&
        Array.isArray(savedProductionMaterials.materials)
      ) {
        materialsArray = savedProductionMaterials.materials;
      }

      console.log(
        "EDIT PRODUCTION MATERIALS =>",
        materialsArray
      );

      console.log(
        "EDIT PRODUCTION GRAND TOTAL =>",
        savedProductionMaterials?.grandTotal
      );

      if (materialsArray.length > 0) {
        setProductionMaterials(
          materialsArray.map((item) => {
            const qty = Number(item?.qtyRequired ?? 0);
            const price = Number(item?.basicPrice ?? 0);

            return {
              productId:
                typeof item?.productId === "object"
                  ? item?.productId?._id ||
                  item?.productId?.id ||
                  ""
                  : item?.productId || "",

              qtyRequired: item?.qtyRequired ?? "",
              basicPrice: item?.basicPrice ?? "",

              total:
                item?.total ??
                Number((qty * price).toFixed(2)),
            };
          })
        );
      } else if (
        editProductSection === "Production" &&
        data?.id
      ) {
        // Existing Production product fallback
        setProductionMaterials([
          {
            productId:
              typeof data.id === "object"
                ? data.id?._id || ""
                : data.id || "",

            qtyRequired: "",
            basicPrice: "",
            total: 0,
          },
        ]);
      } else {
        setProductionMaterials([
          emptyProductionMaterial(),
        ]);
      }

      // ================= PRODUCTION UNITS =================
      let savedProductionUnits = data?.Units;

      if (typeof savedProductionUnits === "string") {
        try {
          savedProductionUnits = JSON.parse(
            savedProductionUnits
          );
        } catch (error) {
          console.log(
            "PRODUCTION UNITS PARSE ERROR =>",
            error
          );

          savedProductionUnits = [];
        }
      }

      const savedUnit = Array.isArray(savedProductionUnits)
        ? savedProductionUnits[0] || {}
        : {};

      setProductionUnits([
        {
          grossQty: savedUnit?.grossQty ?? "",
          grossSqInch: savedUnit?.grossSqInch ?? "",
          grossWeight: savedUnit?.grossWeight ?? "",
        },
      ]);

      console.log(
        "EDIT PRODUCTION UNITS =>",
        savedUnit
      );

    } catch (err) {
      console.log("EDIT PRODUCT ERROR =>", err);

      console.log(
        "EDIT PRODUCT RESPONSE =>",
        err?.response?.data
      );
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    const handleOutsideClick = (
      event
    ) => {
      if (
        stepDropdownRef.current &&
        !stepDropdownRef.current.contains(
          event.target
        )
      ) {
        setShowStepDropdown(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleOutsideClick
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );
    };
  }, []);

  // =========================================================
  // CATEGORY -> SUB CATEGORY
  // =========================================================

  useEffect(() => {
    if (
      categories.length > 0 &&
      form.category
    ) {
      const selectedCategory =
        categories.find(
          (c) =>
            c.name ===
            form.category
        );

      setSubCategories(
        selectedCategory?.subcategories ||
        []
      );
    } else {
      setSubCategories([]);
    }
  }, [
    categories,
    form.category,
  ]);

  // =========================================================
  // FETCH ALL MASTER DATA
  // =========================================================

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const user =
          JSON.parse(
            localStorage.getItem(
              "userData"
            )
          );

        if (!user?.database) {
          return;
        }

        // ===================================================
        // UNITS
        // ===================================================

        const unitRes =
          await _GetByUrl(
            viewUnits,
            user.database
          );

        const dynamicUnits =
          unitRes?.dynamicUnit ||
          [];

        const allUnits =
          dynamicUnits.flatMap(
            (item) =>
              (item.Units || []).map(
                (u) => ({
                  ...u,
                  parentId:
                    item._id,
                })
              )
          );

        setUnits(
          allUnits || []
        );

        // ===================================================
        // WAREHOUSE
        // ===================================================

        const warehouseRes =
          await axiosConfig.get(
            `/warehouse/view-warehouse/${user.database}`
          );

        setWarehouses(
          warehouseRes?.data
            ?.Warehouse || []
        );

        // ===================================================
        // CATEGORY
        // ===================================================

        const categoryRes =
          await AllCategoryList(
            user._id,
            user.database
          );

        setCategories(
          categoryRes?.Category ||
          []
        );

        // ===================================================
        // PRODUCTION STEPS
        // ===================================================

        const productStep = await axiosConfig.get(
          `/production-step/view-steps/${user?._id}`
        );

        console.log("STEP API RESPONSE =>", productStep.data);

        const stepsData = productStep?.data?.steps?.flatMap(
          (item) => item.steps || []
        ) || [];

        console.log("FINAL STEP LIST =>", stepsData);

        setProductStep(stepsData);
        // ===================================================
        // PRODUCTS
        // ===================================================

        const res =
          await axiosConfig.get(
            `/product/view-product-purchase/${user.database}`
          );

        const allProducts =
          res?.data?.Product ||
          [];

        setProducts(
          allProducts
        );

        // ===================================================
        // RAW MATERIAL PRODUCTS
        // ===================================================

        const rawMaterialProducts =
          allProducts.filter(
            (item) =>
              String(
                item?.type ||
                ""
              )
                .trim()
                .toLowerCase() ===
              "trading"
          );

        setRawProducts(
          rawMaterialProducts
        );
      } catch (err) {
        console.log(
          "FETCH MASTER DATA ERROR =>",
          err
        );
      }
    };

    fetchAllData();
  }, []);

  // =========================================================
  // PRODUCT SECTION CHANGE
  // =========================================================

  const handleProductSectionChange = (value) => {
    setProductSection(value);

    // Final Product select kiya
    if (value === "Final Product") {
      setProductionMaterials([emptyProductionMaterial()]);
    }

    // Production select kiya
    if (value === "Production") {
      setProductSpecification([emptySpecification()]);
      setProductionUnits([emptyProductionUnit()]);

      // Category, SubCategory aur Warehouse clear nahi honge
      setForm((prev) => ({
        ...prev,
        step_Name: [],
        productType: "Parent",
      }));
    }

    // Blank select kiya
    if (!value) {
      setProductSpecification([emptySpecification()]);
      setProductionMaterials([emptyProductionMaterial()]);
      setProductionUnits([emptyProductionUnit()]);

      // Category, SubCategory aur Warehouse preserve rahenge
      setForm((prev) => ({
        ...prev,
        step_Name: [],
        productType: "Parent",
      }));
    }
  };

  // =========================================================
  // SPECIFICATION CHANGE
  // =========================================================

  const handleSpecificationChange = (
    index,
    field,
    value
  ) => {
    setProductSpecification(
      (prev) => {
        const updated = [
          ...prev,
        ];

        updated[index] = {
          ...updated[index],
          [field]: value,
        };

        return updated;
      }
    );
  };

  // =========================================================
  // ADD SPECIFICATION
  // =========================================================

  const addProductSpecification = () => {
    setProductSpecification(
      (prev) => [
        ...prev,
        emptySpecification(),
      ]
    );
  };

  // =========================================================
  // REMOVE SPECIFICATION
  // =========================================================

  const removeProductSpecification = (
    index
  ) => {
    setProductSpecification(
      (prev) =>
        prev.filter(
          (_, i) =>
            i !== index
        )
    );
  };

  // =========================================================
  // PRODUCTION MATERIAL CHANGE
  // =========================================================

  const handleProductionMaterialChange = (
    index,
    field,
    value
  ) => {
    setProductionMaterials(
      (prev) => {
        const updated = [
          ...prev,
        ];

        const row = {
          ...updated[index],
          [field]: value,
        };

        // ===============================================
        // RAW MATERIAL SELECT
        // ===============================================

        if (
          field ===
          "productId"
        ) {
          const selectedProduct =
            rawProducts.find(
              (item) =>
                String(
                  item?._id
                ) ===
                String(value)
            );

          const basicPrice =
            Number(
              selectedProduct
                ?.purchaseRatePerGrossSqInch ||
              0
            );

          row.basicPrice =
            basicPrice;

          row.total =
            Number(
              row.qtyRequired ||
              0
            ) *
            basicPrice;
        }

        // ===============================================
        // QTY CHANGE
        // ===============================================

        if (
          field ===
          "qtyRequired"
        ) {
          row.total =
            Number(
              value || 0
            ) *
            Number(
              row.basicPrice ||
              0
            );
        }

        // ===============================================
        // BASIC PRICE CHANGE
        // ===============================================

        if (
          field ===
          "basicPrice"
        ) {
          row.total =
            Number(
              row.qtyRequired ||
              0
            ) *
            Number(
              value || 0
            );
        }

        updated[index] =
          row;

        return updated;
      }
    );
  };

  // =========================================================
  // ADD PRODUCTION MATERIAL
  // =========================================================

  const addProductionMaterial =
    () => {
      setProductionMaterials(
        (prev) => [
          ...prev,
          emptyProductionMaterial(),
        ]
      );
    };

  // =========================================================
  // REMOVE PRODUCTION MATERIAL
  // =========================================================

  const removeProductionMaterial = (
    index
  ) => {
    setProductionMaterials(
      (prev) =>
        prev.filter(
          (_, i) =>
            i !== index
        )
    );
  };

  // =========================================================
  // MAIN INPUT CHANGE
  // =========================================================

  const handleChange = (
    e
  ) => {
    const {
      name,
      value,
    } = e.target;

    // =====================================================
    // TYPE CHANGE
    // =====================================================


    // =====================================================
    // TYPE CHANGE
    // =====================================================

    if (name === "type") {
      setForm((prev) => ({
        ...prev,

        // Sirf Type change hoga
        type: value,

        // Category aur SubCategory preserve rahenge
        category: prev.category,
        SubCategory: prev.SubCategory,

        // Warehouse bhi preserve rahega
        warehouse: prev.warehouse,

        // Step reset
        step_Name: [],

        productType:
          value === "Production"
            ? "Parent"
            : "",
      }));

      // Trading select karne par Product Section reset
      if (value !== "Production") {
        setProductSection("");

        setProductSpecification([
          emptySpecification(),
        ]);

        setProductionUnits([
          emptyProductionUnit(),
        ]);

        setProductionMaterials([
          emptyProductionMaterial(),
        ]);
      }

      return;
    }


    // =====================================================
    // CATEGORY CHANGE
    // =====================================================

    if (
      name ===
      "category"
    ) {
      const selected =
        categories.find(
          (c) =>
            c.name ===
            value
        );

      setSubCategories(
        selected?.subcategories ||
        []
      );

      setForm(
        (prev) => ({
          ...prev,

          category:
            value,

          SubCategory: "",
        })
      );

      return;
    }

    // =====================================================
    // NORMAL CHANGE
    // =====================================================

    setForm(
      (prev) => ({
        ...prev,
        [name]: value,
      })
    );
  };

  // =========================================================
  // FILTERED WAREHOUSE
  // =========================================================

  const filteredWarehouses = warehouses.filter(
    (warehouse) =>
      String(warehouse?.warehouseType || "")
        .trim()
        .toLowerCase() ===
      String(form.type || "")
        .trim()
        .toLowerCase()
  );

  // =========================================================
  // PARENT PRODUCT
  // ONLY FINAL PRODUCT
  // =========================================================

  const parentProduct =
    (isFinalProduct || isProductionSection)
      ? products.find(
        (item) =>
          item.category === form.category &&
          item.SubCategory === form.SubCategory &&
          String(item.productType || "").toLowerCase() ===
          "parent" &&
          item._id !== productId
      )
      : null;

  const availableProductTypes =
    (isFinalProduct || isProductionSection)
      ? parentProduct
        ? ["Child"]
        : ["Parent"]
      : [];



  // =========================================================
  // AUTO PARENT / CHILD
  // =========================================================

  useEffect(() => {
    if (isEdit) {
      return;
    }

    if (!isFinalProduct && !isProductionSection) {
      return;
    }

    if (!form.category || !form.SubCategory) {
      return;
    }

    setForm((prev) => ({
      ...prev,
      productType: parentProduct
        ? "Child"
        : "Parent",
    }));
  }, [
    form.category,
    form.SubCategory,
    parentProduct,
    isFinalProduct,
    isProductionSection,
    isEdit,
  ]);

  useEffect(() => {
    if (isEdit || !isProductionSection) return;
    if (form.productType !== "Child") return;

    let parentUnits = parentProduct?.Units ?? [];

    if (typeof parentUnits === "string") {
      try {
        parentUnits = JSON.parse(parentUnits);
      } catch (error) {
        console.log("PARENT UNITS PARSE ERROR =>", error);
        parentUnits = [];
      }
    }

    const parentUnit = Array.isArray(parentUnits)
      ? parentUnits[0] || {}
      : {};

    setProductionUnits([
      {
        grossQty: parentUnit?.grossQty ?? "",
        grossSqInch: parentUnit?.grossSqInch ?? "",
        grossWeight: parentUnit?.grossWeight ?? "",
      },
    ]);
  }, [
    isProductionSection,
    form.productType,
    parentProduct,
    isEdit,
  ]);


  // =========================================================
  // HANDLE SUBMIT
  // =========================================================

  const handleSubmit = async (
    e
  ) => {
    e.preventDefault();

    // =====================================================
    // FINAL PRODUCT PARENT VALIDATION
    // =====================================================

    if (
      isFinalProduct &&
      form.productType ===
      "Child" &&
      !parentProduct
    ) {
      return swal(
        "Warning",
        "Please create Parent Product first.",
        "warning"
      );
    }

    if (
      isFinalProduct &&
      form.productType ===
      "Parent"
    ) {
      const alreadyParent =
        products.find(
          (item) =>
            item.category ===
            form.category &&
            item.SubCategory ===
            form.SubCategory &&
            item.productType ===
            "Parent" &&
            item._id !==
            productId
        );

      if (alreadyParent) {
        return swal(
          "Warning",
          "Parent Product already exists.",
          "warning"
        );
      }
    }

    // =====================================================
    // PRODUCT SECTION REQUIRED FOR PRODUCTION
    // =====================================================

    if (
      isProduction &&
      !productSection
    ) {
      return swal(
        "Warning",
        "Please select Product Section.",
        "warning"
      );
    }

    try {
      setLoading(true);

      const user =
        JSON.parse(
          localStorage.getItem(
            "userData"
          )
        );

      const formdata =
        new FormData();

      // =====================================================
      // DEFAULT FIELDS
      // =====================================================

      formdata.append(
        "created_by",
        user?._id
      );

      formdata.append(
        "database",
        user?.database
      );

      // =====================================================
      // ID FIELD - ADD / EDIT
      // =====================================================

      if (isEdit) {
        // Edit ke time actual MongoDB product ID
        formdata.set("id", productId);
      } else if (isFinalProduct) {
        // Final Product ke liye selected Raw Material ID
        const selectedRawMaterialId =
          productionMaterials.find(
            (item) => item?.productId
          )?.productId || "";

        formdata.set("id", selectedRawMaterialId);
      } else {
        // New Trading / Production product ke liye Product Title
        formdata.set("id", form.Product_Title || "");
      }

      console.log("IS EDIT =>", isEdit);
      console.log("ID SENT TO API =>", formdata.get("id"));

      // =====================================================
      // PRODUCT SECTION
      // =====================================================

      if (isProduction) {
        formdata.append(
          "productSection",
          productSection
        );
      }
      // =====================================================
      // PRODUCTION ITEM TYPE - TRADING / PRODUCTION
      // =====================================================

      if (
        isTrading ||
        (isProduction && productSection === "Production")
      ) {
        if (productionItemType) {
          formdata.set(
            "productionItemType",
            productionItemType
          );
        }
      }
      // =====================================================
      // FORM VALUES
      // =====================================================

      Object.entries(
        form
      ).forEach(
        ([key, value]) => {
          if (
            value === "" ||
            value === null ||
            value === undefined
          ) {
            return;
          }

          // ===============================================
          // STEP NAME
          // ===============================================

          // STEP NAME => current_Step (single Step Name)
          if (key === "step_Name") {
            formdata.delete("step_Name");

            const selectedStepId = Array.isArray(value)
              ? value[0]
              : value;

            const selectedStep = productstep.find(
              (step) =>
                String(step._id) === String(selectedStepId)
            );

            formdata.set(
              "current_Step",
              selectedStep?.step_Name || ""
            );

            return;
          }

          // ===============================================
          // PRODUCT TYPE
          // Only Final Product
          // ===============================================

          if (
            key === "productType" &&
            !isFinalProduct &&
            !isProductionSection
          ) {
            return;
          }

          // ===============================================
          // FINAL PRODUCT ONLY FIELDS
          // ===============================================

          if (
  ["category", "SubCategory", "productType"].includes(key) &&
  !isFinalProduct &&
  !isProductionSection &&
  !isTrading
) {
  return;
} 

          // ===============================================
          // TRADING ONLY GST FIELDS
          // ===============================================

         if (isTrading) {
  formdata.set("gstType", form.gstType || "");
}

          if (
            key ===
            "HSN_Code" &&
            !isTrading
          ) {
            return;
          }

          if (
            key ===
            "GSTRate" &&
            !isTrading
          ) {
            return;
          }

          formdata.append(
            key,
            value
          );
        }
      );
      // =====================================================
      // TRADING GROSS DETAILS + RATE PER SQ INCH
      // =====================================================

     // =====================================================
// TRADING GROSS DETAILS + RATE PER SQ INCH
// =====================================================

if (isTrading) {
  const tradingUnits = [
    {
      grossQty: Number(form.grossQty || 0),
      grossSqInch: Number(form.grossSqInch || 0),
      grossWeight: Number(form.grossWeight || 0),
    },
  ];

  formdata.set(
    "Units",
    JSON.stringify(tradingUnits)
  );

  formdata.set(
    "purchaseRatePerGrossSqInch",
    String(form.purchaseRatePerGrossSqInch ?? "")
  );

  // Purane direct fields remove
  formdata.delete("grossQty");
  formdata.delete("grossSqInch");
  formdata.delete("grossWeight");
}

      // =====================================================
      // FINAL PRODUCT SPECIFICATION
      // =====================================================

      if (
        isFinalProduct
      ) {
        const validSpecifications =
          productSpecification.filter(
            (item) =>
              Object.values(
                item
              ).some(
                (value) =>
                  value !==
                  "" &&
                  value !==
                  null &&
                  value !==
                  undefined
              )
          );

        const finalSpecifications =
          validSpecifications.map(
            (item) => ({
              netQty:
                Number(
                  item.netQty ||
                  0
                ),

              netSqInch:
                Number(
                  item.netSqInch ||
                  0
                ),

              netWeight:
                Number(
                  item.netWeight ||
                  0
                ),

              grossQty:
                Number(
                  item.grossQty ||
                  0
                ),

              grossSqInch:
                Number(
                  item.grossSqInch ||
                  0
                ),

              grossWeight:
                Number(
                  item.grossWeight ||
                  0
                ),

              qtyInBundle:
                Number(
                  item.qtyInBundle ||
                  0
                ),

              qtyInBag:
                Number(
                  item.qtyInBag ||
                  0
                ),

              noOfBundleInBag:
                Number(
                  item.noOfBundleInBag ||
                  0
                ),

              weightOfBundle:
                Number(
                  item.weightOfBundle ||
                  0
                ),

              weightOfBag:
                Number(
                  item.weightOfBag ||
                  0
                ),

              wastageSqInch:
                Number(
                  item.wastageSqInch ||
                  0
                ),

              wastageWeight:
                Number(
                  item.wastageWeight ||
                  0
                ),
            })
          );

        formdata.append(
          "productSpecification",
          JSON.stringify(
            finalSpecifications
          )
        );
      }


      if (isProductionSection) {
        const validProductionUnits = productionUnits
          .filter(
            (item) =>
              item.grossQty !== "" ||
              item.grossSqInch !== "" ||
              item.grossWeight !== ""
          )
          .map((item) => ({
            grossQty: Number(item.grossQty || 0),
            grossSqInch: Number(item.grossSqInch || 0),
            grossWeight: Number(item.grossWeight || 0),
          }));

        formdata.set(
          "Units",
          JSON.stringify(validProductionUnits)
        );
      }
      // ================= PRODUCTION MATERIALS =================
      if (isFinalProduct || isProductionSection) {
        const validMaterials = productionMaterials
          .filter((item) => item?.productId)
          .map((item) => {
            const qty = Number(item.qtyRequired || 0);
            const price = Number(item.basicPrice || 0);

            return {
              productId: item.productId,
              qtyRequired: qty,
              basicPrice: price,
              total: Number((qty * price).toFixed(2)),
            };
          });

        // Grand Total = all material totals ka sum
        const grandTotal = Number(
          validMaterials
            .reduce((sum, item) => sum + item.total, 0)
            .toFixed(2)
        );

        // Grand Total productionMaterials array ke andar
        const productionMaterialsPayload = {
          materials: validMaterials,
          grandTotal: grandTotal,
        };

        formdata.set(
          "productionMaterials",
          JSON.stringify(productionMaterialsPayload)
        );
      }

      // =====================================================
      // DEBUG FORMDATA
      // =====================================================

      console.log(
        "========== FORMDATA =========="
      );

      for (
        const pair of formdata.entries()
      ) {
        console.log(
          pair[0],
          pair[1]
        );
      }
      // =====================================================
      // UPDATE
      // =====================================================

      for (const pair of formdata.entries()) {
        console.log(pair[0], "=>", pair[1]);
      }
      console.log("========== PRODUCT PAYLOAD START ==========");

      const payloadObject = {};

      for (const [key, value] of formdata.entries()) {
        let parsedValue = value;

        // JSON fields ko object/array ke form me console me dikhaye
        if (typeof value === "string") {
          try {
            parsedValue = JSON.parse(value);
          } catch {
            parsedValue = value;
          }
        }

        payloadObject[key] = parsedValue;

        console.log(`${key} =>`, parsedValue);
      }

      console.log("========== COMPLETE PAYLOAD ==========");
      console.log(payloadObject);

      console.log("Production Units:", payloadObject.Units);
      console.log("Production Materials:", payloadObject.productionMaterials);
      console.log("Grand Total:", payloadObject.grandTotal);

      console.log("Is Edit:", isEdit);
      console.log("Product ID:", isEdit ? productId : "New Product");
      console.log("========== PRODUCT PAYLOAD END ==========");
      if (isEdit) {
        const res =
          await _Put(
            Update_Product,
            productId,
            formdata
          );

        if (
          res?.status
        ) {
          await swal(
            "Success",
            "Product Updated Successfully",
            "success"
          );

          localStorage.removeItem(
            STORAGE_KEY
          );

          navigate(
            "/production?view=products"
          );
        }
      }

      // =====================================================
      // CREATE
      // =====================================================

      else {
        const res =
          await SaveProduct(
            formdata
          );

        if (
          res?.status
        ) {
          localStorage.removeItem(
            STORAGE_KEY
          );

          await swal(
            "Success",
            "Product Added Successfully",
            "success"
          );

          navigate(
            "/production?view=products"
          );
        }
      }
    } catch (err) {
      console.log(
        "ERROR =>",
        err?.response?.data
      );

      swal(
        "Error",
        err?.response?.data
          ?.message ||
        "Something Went Wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // BULK UPLOAD
  // =========================================================

  const handleBulkUpload =
    async (e) => {
      e.preventDefault();

      const userData =
        JSON.parse(
          localStorage.getItem(
            "userData"
          )
        );

      if (!BulkImport) {
        return swal(
          "Please Choose File"
        );
      }

      if (
        !uploadForm?.UploadStatus
      ) {
        return swal(
          "Choose Type of Upload"
        );
      }

      try {
        setLoading(true);

        const formdata =
          new FormData();

        formdata.append(
          "file",
          BulkImport
        );

        formdata.append(
          "database",
          userData?.database
        );

        // ===================================================
        // UPDATE
        // ===================================================

        if (
          uploadForm?.UploadStatus ===
          "Update"
        ) {
          const URL = `${Bulk_Update_Product}/${userData?.database}`;

          const res =
            await _BulkUpload(
              URL,
              formdata
            );

          if (
            res?.status
          ) {
            await swal(
              "Success",
              "Product Updated Successfully",
              "success"
            );

            navigate(
              "/production?view=products"
            );
          } else {
            swal(
              "Error",
              "Error In Updating Product",
              "error"
            );
          }
        }

        // ===================================================
        // NEW UPLOAD
        // ===================================================

        else if (
          uploadForm?.UploadStatus ===
          "New Upload"
        ) {
          const URL = `${Bulk_Upload_Product}/${userData?.database}`;

          const res =
            await _BulkUpload(
              URL,
              formdata
            );

          if (
            res?.status
          ) {
            await swal(
              "Success",
              "Product Added Successfully",
              "success"
            );

            navigate(
              "/production?view=products"
            );
          } else {
            swal(
              "Error",
              "Error In Adding Product",
              "error"
            );
          }
        }
      } catch (err) {
        console.log(
          err?.response
        );

        setBulkImport(null);

        swal(
          "Error",
          "Something Went Wrong",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

  // =========================================================
  // LOCAL STORAGE SAVE
  // =========================================================

  useEffect(() => {
    if (!isEdit) {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          form,
          productSection,
          productSpecification,
          productionMaterials,
          productionUnits,
        })
      );
    }
  }, [
    form,
    productSection,
    productSpecification,
    productionMaterials,
    productionUnits,
    isEdit,
  ]);

  // =========================================================
  // LOADING SCREEN
  // =========================================================

  if (loading) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: 100,
        }}
      >
        <Spinner />
      </div>
    );
  }

  // =========================================================
  // JSX
  // =========================================================

  return (
    <div className="erp-page-grid">
      {/* ================= HEADER ================= */}
      <Row style={{ marginBottom: "15px", alignItems: "center" }}>
        <Col md="8">
          <h2>{isEdit ? "Update Product" : "Add Product"}</h2>
        </Col>

        {!BulkUpload && (
          <>
            <Col md="3" className="text-end">
              <Button color="primary" onClick={() => setBulkUpload(true)}>
                Bulk Upload
              </Button>
            </Col>

            <Col md="1">
              <Button
                color="secondary"
                onClick={() => navigate("/production?view=products")}
              >
                Back
              </Button>
            </Col>
          </>
        )}
      </Row>

      {/* ================= BULK UPLOAD ================= */}
      {BulkUpload ? (
        <form onSubmit={handleBulkUpload}>
          <Label>
            Choose Type of Upload <span className="text-danger">*</span>
          </Label>

          <Row className="mb-3">
            <Col md="12">
              <div>
                <Input
                  type="radio"
                  name="UploadStatus"
                  value="New Upload"
                  checked={uploadForm?.UploadStatus === "New Upload"}
                  onChange={(e) =>
                    setUploadForm({
                      ...uploadForm,
                      UploadStatus: e.target.value,
                    })
                  }
                />
                <span className="mx-2">New Upload</span>

                <Input
                  type="radio"
                  name="UploadStatus"
                  value="Update"
                  checked={uploadForm?.UploadStatus === "Update"}
                  onChange={(e) =>
                    setUploadForm({
                      ...uploadForm,
                      UploadStatus: e.target.value,
                    })
                  }
                />
                <span className="mx-2">Update</span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md="4">
              <Label>Bulk Import File</Label>
              <Input
                type="file"
                required
                onChange={(e) => setBulkImport(e.target.files[0])}
              />
            </Col>
          </Row>

          <div className="mt-3">
            <Button color="primary" type="submit">
              Import
            </Button>

            <Button
              type="button"
              color="secondary"
              className="ms-2"
              onClick={() => setBulkUpload(false)}
            >
              Cancel
            </Button>
          </div>
        </form>
      ) : (
        <form onSubmit={handleSubmit}>
          <Row>
            {/* CATEGORY */}
            <Col md="3" className="mb-3">
              <Label>
                Category <span className="text-danger">*</span>
              </Label>

              <Input
                type="select"
                name="category"
                value={form.category}
                onChange={handleChange}
                required
              >
                <option value="">Select Category</option>

                {categories.map((category) => (
                  <option key={category?._id} value={category?.name}>
                    {category?.name}
                  </option>
                ))}
              </Input>
            </Col>

            {/* SUB CATEGORY */}
            <Col md="3" className="mb-3">
              <Label>
                Sub Category <span className="text-danger">*</span>
              </Label>

              <Input
                type="select"
                name="SubCategory"
                value={form.SubCategory}
                onChange={handleChange}
                required
              >
                <option value="">Select Sub Category</option>

                {subCategories.map((subCategory, index) => (
                  <option
                    key={subCategory?._id || index}
                    value={subCategory?.name}
                  >
                    {subCategory?.name}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>

          {/* ================= TYPE, PRODUCT SECTION, ITEM TYPE ================= */}
          <Row className="mt-3">
            {/* TYPE */}
            <Col md="3" className="mb-3">
              <Label>
                Type <span className="text-danger">*</span>
              </Label>

              <Input
                type="select"
                name="type"
                value={form.type}
                onChange={handleChange}
                required
              >
                <option value="">Select Type</option>
                <option value="Trading">Trading</option>
                <option value="Production">Production</option>
              </Input>
            </Col>

            {/* PRODUCT SECTION */}
            {isProduction && (
              <Col md="3" className="mb-3">
                <Label>
                  Product Section <span className="text-danger">*</span>
                </Label>

                <Input
                  type="select"
                  value={productSection}
                  onChange={(e) => handleProductSectionChange(e.target.value)}
                  required
                >
                  <option value="">Select Product Section</option>
                  <option value="Final Product">Final Product</option>
                  <option value="Production">Production</option>
                </Input>
              </Col>
            )}

            {/* PRODUCTION ITEM TYPE */}
            {(isTrading ||
              (isProduction && productSection === "Production")) && (
                <Col md="3" className="mb-3">
                  <Label>Production Item Type</Label>

                  <Input
                    type="select"
                    value={productionItemType}
                    onChange={(e) => setProductionItemType(e.target.value)}
                  >
                    <option value="">Select Item Type</option>
                    <option value="Raw Material">Raw Material</option>
                    <option value="Product">Sales</option>
                  </Input>
                </Col>
              )}
          </Row>
          <Row className="mt-3">
            {/* WAREHOUSE */}
            <Col md="3" className="mb-3">
              <Label>
                Warehouse <span className="text-danger">*</span>
              </Label>

              <Input
                type="select"
                name="warehouse"
                value={form.warehouse}
                onChange={handleChange}
                required
              >
                <option value="">Select Warehouse</option>

                {filteredWarehouses.map((warehouse) => (
                  <option key={warehouse?._id} value={warehouse?._id}>
                    {warehouse?.warehouseName}
                  </option>
                ))}
              </Input>
            </Col>


            {/* STEP NAME — Sub Category ke baad */}
            {!isFinalProduct && (
              <Col md="3">
                <FormGroup>
                  <Label>Step Name</Label>

                  <div className="position-relative" ref={stepDropdownRef}>
                    <Button
                      type="button"
                      color="light"
                      className="w-100 d-flex justify-content-between align-items-center border"
                      onClick={() => setShowStepDropdown((prev) => !prev)}
                    >
                      <span
                        className="text-truncate text-start"
                        style={{ maxWidth: "90%" }}
                      >
                        {form.step_Name
                          ? productstep.find(
                            (step) =>
                              String(step._id) === String(form.step_Name)
                          )?.step_Name || "Select Step Name"
                          : "Select Step Name"}
                      </span>

                      <span>▼</span>
                    </Button>

                    {showStepDropdown && (
                      <div
                        className="border rounded bg-white p-2 mt-1 position-absolute w-100"
                        style={{
                          zIndex: 1050,
                          maxHeight: "220px",
                          overflowY: "auto",
                        }}
                      >
                        {productstep?.length > 0 ? (
                          productstep.map((step) => (
                            <FormGroup check key={step._id} className="mb-2">
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={
                                    String(form.step_Name || "") === String(step._id)
                                  }
                                  onChange={(e) => {
                                    const checked = e.target.checked;

                                    setForm((prev) => ({
                                      ...prev,
                                      step_Name: checked ? step._id : "",
                                    }));
                                  }}
                                />

                                {step.step_Name}
                              </Label>
                            </FormGroup>
                          ))
                        ) : (
                          <div className="text-muted">No steps available</div>
                        )}
                      </div>
                    )}
                  </div>
                </FormGroup>
              </Col>
            )}
          </Row>
          {/* =====================================================
            TRADING FIELDS
        ===================================================== */}
          {isTrading && (
            <>
              <Row>
                {/* PRODUCT NAME */}
                <Col md="3" className="mb-3">
                  <Label>
                    Product Name <span className="text-danger">*</span>
                  </Label>

                  <Input
                    name="Product_Title"
                    value={form.Product_Title}
                    onChange={handleChange}
                    required
                  />
                </Col>

                {/* GST TYPE */}
                <Col md="3" className="mb-3">
                  <Label>
                    GST Type <span className="text-danger">*</span>
                  </Label>

                  <Input
                    type="select"
                    name="gstType"
                    value={form.gstType}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select GST Type</option>
                    <option value="CGST/SGST">CGST/SGST</option>
                    <option value="IGST">IGST</option>
                  </Input>
                </Col>

                {/* HSN */}
                <Col md="3" className="mb-3">
                  <Label>
                    HSN <span className="text-danger">*</span>
                  </Label>

                  <Input
                    name="HSN_Code"
                    value={form.HSN_Code}
                    onChange={handleChange}
                    required
                  />
                </Col>

                {/* GST PERCENTAGE */}
                <Col md="3" className="mb-3">
                  <Label>
                    GST Percentage <span className="text-danger">*</span>
                  </Label>

                  <Input
                    type="number"
                    name="GSTRate"
                    value={form.GSTRate}
                    onChange={handleChange}
                    required
                  />
                </Col>

                {/* OPENING STOCK */}
                <Col md="3" className="mb-3">
                  <Label>Opening Stock</Label>

                  <Input
                    type="number"
                    name="Opening_Stock"
                    value={form.Opening_Stock}
                    onChange={handleChange}
                  />
                </Col>

                {/* OPENING RATE */}
                <Col md="3" className="mb-3">
                  <Label>Opening Rate</Label>

                  <Input
                    type="number"
                    name="openingRate"
                    value={form.openingRate}
                    onChange={handleChange}
                  />
                </Col>

                {/* PRIMARY UNIT */}
                <Col md="3" className="mb-3">
                  <Label>Primary Unit</Label>

                  <Input
                    type="select"
                    name="primaryUnit"
                    value={form.primaryUnit}
                    onChange={handleChange}
                  >
                    <option value="">Select Unit</option>

                    {units.map((unit, index) => (
                      <option key={unit?._id || index} value={unit.unitName}>
                        {unit.unitName}
                      </option>
                    ))}
                  </Input>
                </Col>

                {/* SECONDARY UNIT */}
                <Col md="3" className="mb-3">
                  <Label>Secondary Unit</Label>

                  <Input
                    type="select"
                    name="secondaryUnit"
                    value={form.secondaryUnit}
                    onChange={handleChange}
                  >
                    <option value="">Select Unit</option>

                    {units.map((unit, index) => (
                      <option key={unit?._id || index} value={unit.unitName}>
                        {unit.unitName}
                      </option>
                    ))}
                  </Input>
                </Col>

                {/* SECONDARY QTY */}
                <Col md="3" className="mb-3">
                  <Label>Secondary Qty</Label>

                  <Input
                    type="number"
                    name="secondarySize"
                    value={form.secondarySize}
                    onChange={handleChange}
                  />
                </Col>

                {/* MIN STOCK */}
                <Col md="3" className="mb-3">
                  <Label>Product Min Stock</Label>

                  <Input
                    type="number"
                    name="MIN_stockalert"
                    value={form.MIN_stockalert}
                    onChange={handleChange}
                  />
                </Col>

                {/* PURCHASE RATE */}
                <Col md="3" className="mb-3">
                  <Label>
                    Purchase Rate (Basic Rate) <span className="text-danger">*</span>
                  </Label>

                  <Input
                    type="number"
                    name="Purchase_Rate"
                    value={form.Purchase_Rate}
                    onChange={handleChange}
                    required
                  />
                </Col>

                {/* STATUS */}
                <Col md="3" className="mb-3">
                  <Label>Status</Label>

                  <Input
                    type="select"
                    name="status"
                    value={form.status}
                    onChange={handleChange}
                  >
                    <option value="Active">Active</option>
                    <option value="Deactive">Deactive</option>
                  </Input>
                </Col>
              </Row>

              {/* GROSS DETAILS - TRADING */}
              <Row>
                <Col md="3">
                  <FormGroup>
                    <Label>Gross Qty</Label>
                    <Input
                      type="number"
                      name="grossQty"
                      value={form.grossQty || ""}
                      onChange={handleChange}
                      placeholder="Enter Gross Qty"
                    />
                  </FormGroup>
                </Col>

                <Col md="3">
                  <FormGroup>
                    <Label>Gross Sq Inch</Label>
                    <Input
                      type="number"
                      name="grossSqInch"
                      value={form.grossSqInch || ""}
                      onChange={handleChange}
                      placeholder="Enter Gross Sq Inch"
                    />
                  </FormGroup>
                </Col>

                <Col md="3">
                  <FormGroup>
                    <Label>Gross Weight</Label>
                    <Input
                      type="number"
                      name="grossWeight"
                      value={form.grossWeight || ""}
                      onChange={handleChange}
                      placeholder="Enter Gross Weight"
                    />
                  </FormGroup>
                </Col>

                <Col md="3">
                  <FormGroup>
                    <Label>Rate Per Sq Inch</Label>
                    <Input
                      type="number"
                      name="purchaseRatePerGrossSqInch"
                      value={form.purchaseRatePerGrossSqInch || ""}
                      readOnly
                      placeholder="Auto Calculated"
                    />
                  </FormGroup>
                </Col>

              </Row>

            </>
          )}

          {/* =====================================================
            PRODUCTION: FINAL PRODUCT
        ===================================================== */}
          {isFinalProduct && (
            <>
              <Row>
                {/* PRODUCT TYPE */}
                <Col md="3" className="mb-3">
                  <Label>Product Type</Label>

                  <Input
                    type="select"
                    name="productType"
                    value={form.productType}
                    onChange={handleChange}
                  >
                    {availableProductTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </Input>
                </Col>

                {/* PRODUCT NAME */}
                <Col md="3" className="mb-3">
                  <Label>
                    Product Name <span className="text-danger">*</span>
                  </Label>

                  <Input
                    name="Product_Title"
                    value={form.Product_Title}
                    onChange={handleChange}
                    required
                  />
                </Col>

                {/* OPENING STOCK */}
                <Col md="3" className="mb-3">
                  <Label>Opening Stock</Label>

                  <Input
                    type="number"
                    name="Opening_Stock"
                    value={form.Opening_Stock}
                    onChange={handleChange}
                  />
                </Col>

                {/* OPENING RATE */}
                <Col md="3" className="mb-3">
                  <Label>Opening Rate</Label>

                  <Input
                    type="number"
                    name="openingRate"
                    value={form.openingRate}
                    onChange={handleChange}
                  />
                </Col>

                {/* PRIMARY UNIT */}
                <Col md="3" className="mb-3">
                  <Label>Primary Unit</Label>

                  <Input
                    type="select"
                    name="primaryUnit"
                    value={form.primaryUnit}
                    onChange={handleChange}
                  >
                    <option value="">Select Unit</option>

                    {units.map((unit, index) => (
                      <option key={unit?._id || index} value={unit.unitName}>
                        {unit.unitName}
                      </option>
                    ))}
                  </Input>
                </Col>

                {/* SECONDARY UNIT */}
                <Col md="3" className="mb-3">
                  <Label>Secondary Unit</Label>

                  <Input
                    type="select"
                    name="secondaryUnit"
                    value={form.secondaryUnit}
                    onChange={handleChange}
                  >
                    <option value="">Select Unit</option>

                    {units.map((unit, index) => (
                      <option key={unit?._id || index} value={unit.unitName}>
                        {unit.unitName}
                      </option>
                    ))}
                  </Input>
                </Col>

                {/* SECONDARY QTY */}
                <Col md="3" className="mb-3">
                  <Label>Secondary Qty</Label>

                  <Input
                    type="number"
                    name="secondarySize"
                    value={form.secondarySize}
                    onChange={handleChange}
                  />
                </Col>

                {/* MIN STOCK */}
                <Col md="3" className="mb-3">
                  <Label>Product Min Stock</Label>

                  <Input
                    type="number"
                    name="MIN_stockalert"
                    value={form.MIN_stockalert}
                    onChange={handleChange}
                  />
                </Col>

                {/* PURCHASE RATE */}
                <Col md="3" className="mb-3">
                  <Label>Purchase Rate</Label>

                  <Input
                    type="number"
                    name="Purchase_Rate"
                    value={form.Purchase_Rate}
                    onChange={handleChange}
                  />
                </Col>
              </Row>

              {/* WHICH STEPS */}


              {/* PRODUCT SPECIFICATION */}
              <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Product Specification</h5>

                  <Button
                    type="button"
                    color="primary"
                    size="sm"
                    onClick={addProductSpecification}
                  >
                    + Add More
                  </Button>
                </div>

                {productSpecification.map((row, index) => (
                  <div key={index} className="border rounded p-3 mb-3">
                    <Row>
                      {[
                        ["Net Qty", "netQty"],
                        ["Net Sq Inch", "netSqInch"],
                        ["Net Weight", "netWeight"],
                        ["Gross Qty", "grossQty"],
                        ["Gross Sq Inch", "grossSqInch"],
                        ["Gross Weight", "grossWeight"],
                        ["Qty In Bundle", "qtyInBundle"],
                        ["Qty In Bag", "qtyInBag"],
                        ["No Of Bundle In Bag", "noOfBundleInBag"],
                        ["Weight Of Bundle", "weightOfBundle"],
                        ["Weight Of Bag", "weightOfBag"],
                        ["Wastage Sq Inch", "wastageSqInch"],
                        ["Wastage Weight", "wastageWeight"],
                      ].map(([label, key]) => (
                        <Col md="3" key={key} className="mb-3">
                          <Label>{label}</Label>

                          <Input
                            type="number"
                            value={row[key] ?? ""}
                            onChange={(e) =>
                              handleSpecificationChange(
                                index,
                                key,
                                e.target.value
                              )
                            }
                          />
                        </Col>
                      ))}
                    </Row>

                    {productSpecification.length > 1 && (
                      <div className="text-end mt-2">
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          onClick={() => removeProductSpecification(index)}
                        >
                          Remove
                        </Button>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* PRODUCT COSTING */}
              <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Product Costing</h5>

                  <Button
                    type="button"
                    color="primary"
                    size="sm"
                    onClick={addProductionMaterial}
                  >
                    + Add More
                  </Button>
                </div>

                {productionMaterials.map((row, index) => {
                  const qty = Number(row.qtyRequired || 0);
                  const price = Number(row.basicPrice || 0);
                  const total = qty * price;

                  return (
                    <div key={index} className="border rounded p-3 mb-3">
                      <Row className="align-items-end">
                        <Col md="3" className="mb-2">
                          <Label>Raw Material</Label>

                          <Input
                            type="select"
                            value={row.productId || ""}
                            onChange={(e) =>
                              handleProductionMaterialChange(
                                index,
                                "productId",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select Raw Material</option>

                            {rawProducts.map((product) => (
                              <option key={product._id} value={product._id}>
                                {product.Product_Title}
                              </option>
                            ))}
                          </Input>
                        </Col>

                        <Col md="3" className="mb-2">
                          <Label>Qty Required</Label>

                          <Input
                            type="number"
                            min="0"
                            value={row.qtyRequired ?? ""}
                            onChange={(e) =>
                              handleProductionMaterialChange(
                                index,
                                "qtyRequired",
                                e.target.value
                              )
                            }
                          />
                        </Col>

                        <Col md="3" className="mb-2">
                          <Label>Basic Price</Label>

                          <Input
                            type="number"
                            min="0"
                            value={row.basicPrice ?? ""}
                            onChange={(e) =>
                              handleProductionMaterialChange(
                                index,
                                "basicPrice",
                                e.target.value
                              )
                            }
                          />
                        </Col>

                        <Col md="3" className="mb-2">
                          <Label>Total</Label>

                          <Input
                            type="text"
                            value={total.toFixed(2)}
                            readOnly
                            style={{
                              background: "#f1f3f5",
                              fontWeight: 600,
                            }}
                          />
                        </Col>

                        {productionMaterials.length > 1 && (
                          <Col md="3" className="mb-2">
                            <Button
                              type="button"
                              color="danger"
                              size="sm"
                              outline
                              onClick={() => removeProductionMaterial(index)}
                            >
                              Remove
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </div>
                  );
                })}

                <div
                  className="d-flex justify-content-end align-items-center border rounded p-3 mt-2"
                  style={{ background: "#f8f9fa" }}
                >
                  <span className="fw-bold me-3">Grand Total:</span>

                  <strong style={{ fontSize: "18px" }}>
                    {productionMaterials
                      .reduce(
                        (sum, row) =>
                          sum +
                          Number(row.qtyRequired || 0) *
                          Number(row.basicPrice || 0),
                        0
                      )
                      .toFixed(2)}
                  </strong>
                </div>
              </div>
            </>
          )}

          {/* =====================================================
            PRODUCTION SECTION
        ===================================================== */}
          {isProductionSection && (
            <>
              <Row>
                {/* PRODUCT TYPE */}
                <Col md="3" className="mb-3">
                  <Label>Product Type</Label>

                  <Input
                    type="select"
                    name="productType"
                    value={form.productType}
                    onChange={handleChange}
                  >
                    <option value="Parent">Parent</option>
                    <option value="Child">Child</option>
                  </Input>
                </Col>

                {/* PRODUCT NAME */}
                <Col md="3" className="mb-3">
                  <Label>
                    Product Name <span className="text-danger">*</span>
                  </Label>

                  <Input
                    name="Product_Title"
                    value={form.Product_Title}
                    onChange={handleChange}
                    required
                  />
                </Col>

                {/* OPENING STOCK */}
                <Col md="3" className="mb-3">
                  <Label>Opening Stock</Label>

                  <Input
                    type="number"
                    name="Opening_Stock"
                    value={form.Opening_Stock}
                    onChange={handleChange}
                  />
                </Col>

                {/* OPENING PRICE */}
                <Col md="3" className="mb-3">
                  <Label>Opening Price</Label>

                  <Input
                    type="number"
                    name="openingRate"
                    value={form.openingRate}
                    onChange={handleChange}
                  />
                </Col>

                {/* PRIMARY UNIT */}
                <Col md="3" className="mb-3">
                  <Label>Primary Unit</Label>

                  <Input
                    type="select"
                    name="primaryUnit"
                    value={form.primaryUnit}
                    onChange={handleChange}
                  >
                    <option value="">Select Unit</option>

                    {units.map((unit, index) => (
                      <option key={unit?._id || index} value={unit?.unitName}>
                        {unit?.unitName}
                      </option>
                    ))}
                  </Input>
                </Col>

                {/* SECONDARY UNIT */}
                <Col md="3" className="mb-3">
                  <Label>Secondary Unit</Label>

                  <Input
                    type="select"
                    name="secondaryUnit"
                    value={form.secondaryUnit}
                    onChange={handleChange}
                  >
                    <option value="">Select Unit</option>

                    {units.map((unit, index) => (
                      <option key={unit?._id || index} value={unit?.unitName}>
                        {unit?.unitName}
                      </option>
                    ))}
                  </Input>
                </Col>

                {/* SECONDARY QTY */}
                <Col md="3" className="mb-3">
                  <Label>Secondary Qty</Label>

                  <Input
                    type="number"
                    name="secondarySize"
                    value={form.secondarySize}
                    onChange={handleChange}
                  />
                </Col>

                {/* MIN STOCK */}
                <Col md="3" className="mb-3">
                  <Label>Min Stock Alert</Label>

                  <Input
                    type="number"
                    name="MIN_stockalert"
                    value={form.MIN_stockalert}
                    onChange={handleChange}
                  />
                </Col>

                {/* PURCHASE RATE */}
                <Col md="3" className="mb-3">
                  <Label>Purchase Rate</Label>

                  <Input
                    type="number"
                    name="Purchase_Rate"
                    value={form.Purchase_Rate}
                    onChange={handleChange}
                  />
                </Col>
                <Col md="3" className="mb-3">
                  <Label>Gross Qty</Label>

                  <Input
                    type="number"
                    value={productionUnits[0]?.grossQty ?? ""}
                    onChange={(e) =>
                      setProductionUnits([
                        {
                          ...(productionUnits[0] || {}),
                          grossQty: e.target.value,
                        },
                      ])
                    }
                  />
                </Col>

                <Col md="3" className="mb-3">
                  <Label>Gross Sq Inch</Label>

                  <Input
                    type="number"
                    value={productionUnits[0]?.grossSqInch ?? ""}
                    onChange={(e) =>
                      setProductionUnits([
                        {
                          ...(productionUnits[0] || {}),
                          grossSqInch: e.target.value,
                        },
                      ])
                    }
                  />
                </Col>

                <Col md="3" className="mb-3">
                  <Label>Gross Weight</Label>

                  <Input
                    type="number"
                    value={productionUnits[0]?.grossWeight ?? ""}
                    onChange={(e) =>
                      setProductionUnits([
                        {
                          ...(productionUnits[0] || {}),
                          grossWeight: e.target.value,
                        },
                      ])
                    }
                  />
                </Col>
              </Row>

              {/* PRODUCTION UNITS */}
              <Row className="mt-3">

              </Row>
            </>
          )}

          {/* =====================================================
            COMMON PRODUCTION STATUS
        ===================================================== */}
          {isProduction && productSection && (
            <Row className="mt-3">
              <Col md="3" className="mb-3">
                <Label>Status</Label>

                <Input
                  type="select"
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                >
                  <option value="Active">Active</option>
                  <option value="Deactive">Deactive</option>
                </Input>
              </Col>
            </Row>
          )}

          {/* ================= SUBMIT ================= */}
          <div className="mt-4">
            <Button color="primary" type="submit" disabled={loading}>
              {isEdit ? "Update Product" : "Save Product"}
            </Button>
          </div>
        </form>
      )}
    </div>
  );
}